import { Component, OnInit, NgZone, ElementRef, ViewChild } from '@angular/core';
import { CookieService } from '../_services/cookie.service';
import { ReportService } from '../inservice/report.service';
import { Footer, SelectItem } from 'primeng/api';
import { FilterService } from "primeng/api";
import { UntypedFormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { Router} from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Lightbox } from 'ngx-lightbox';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
declare var $: any;
@Component({
	selector: 'app-company',
	templateUrl: './company.component.html',
	styleUrls: ['./company.component.css', './company.component.scss']
})
export class CompanyComponent implements OnInit {
	userName: string;
	public logOutFlag = 0;
	public showLogo = 0;
	companyGroupUserList = [];
	userId;
	companyInfo;
	companyGroups;
	companyGroupIndicator = false;
	usersList;
	companyClients;
	includeExternal = true;
	sortOptions: SelectItem[];
	external = "Y"
	sortOrder: number;
	form;
	userform;
	clientform;
	newClient = true
	newCompany = true;
	newGroup = true;
	clientId;
	role = 2;
	roles = [];
	acceptType=[];
	userRemoveIndex;
	userEditId;
	newUser;
	sortField: string;
	allFont = ['Arial', 'Courier New', 'Georgia', 'Lucida Sans Unicode', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana'];
	@ViewChild('excelFile') excelFile: ElementRef;
	@ViewChild('excelFile1') excelFile1: ElementRef;
	@ViewChild('resume') resume: ElementRef;
	@ViewChild('signature') signature: ElementRef;
	@ViewChild('newFile') newFile: ElementRef;
	constructor(private router: Router,private titleService: Title, private ref: ChangeDetectorRef, private FilterService: FilterService, private cookieService: CookieService, private reportService: ReportService, private fb: UntypedFormBuilder, private ngZone: NgZone, private lightbox: Lightbox) {
		this.reportService.stream$.subscribe(this.receiveMessage.bind(this))

		this.getUserDetail();
		this.acceptType=this.reportService.acceptFileType.split(',');
		this.FilterService.register('external', (value: any[], filters) => {
			console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0 || filters == "Y") {
				return true;
			}

			return value == filters;
		});
	}
	receiveMessage(msg : string) {
		console.log(msg); // your message from component A
	 }
	changeCol() {

	}
	logOut() {
		this.logOutFlag++; console.log(this.logOutFlag);
	}
	onSavedLogo(e) {
		//this.tick = +(new Date());
		this.showLogo = e;

	}
	show(x) {
		console.log("show", x)
		setTimeout(() => { console.log("show", x) }, 1000)
		return true;
	}
	stop(e) {
		e.preventDefault();
	}
	phoneInput(event) {
		console.log(event)
		if (event.data == "e") {
			console.log("prevent");
			event.preventDefault();
		}
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	cols;
	clientCols;
	settingsTile = false;
	settingsCols1;
	settingsCols2;
	locationCols;
	groupCols;
	contactCols;
	fileCols;
	E_USERNAME;
	incorrect = "";
	E_PASSWORD;
	erisRowData
	verifyEris() {

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "EDIT_USER_ID":parseInt(this.erisRowData.USER_ID), "FUNCTION_ID": 32};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse.MESSAGE)

				// close the modal. the timeout is to give it time to load. very hacky, find a better way 
				setTimeout(() => { $('#ERISModal').modal('hide'); }, 250);
			} else {
				
				this.incorrect = "";
				let inputJson = { "PROCEDURE": "verifyeriscustomer", "USER_ID": parseInt(this.erisRowData.USER_ID), "USERNAME": this.E_USERNAME, "PASSWORD": this.E_PASSWORD };

				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log("verifyEris", data);
					if (data.RESPONSE_STATUS == 'Y') {

						this.erisRowData.ERIS_CUSTOMER_ID = data.ERIS_CUSTOMER_ID

						let inputJson2 = {
							"PROCEDURE": "updaterwuser", "USER_ID": parseInt(this.erisRowData.USER_ID), "UPDATE_USER_ID": parseInt(this.erisRowData.USER_ID), "ERIS_CUSTOMER_ID": data.ERIS_CUSTOMER_ID,

						}
						this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
							if (data.RESPONSE_STATUS=='N') {
								this.throwError(data)
								return										
							}
							$('#ERISModal').modal('hide');
							for (let i = 0; i < this.usersList.length; i++) {
								if (this.usersList[i].USER_ID == parseInt(this.erisRowData.USER_ID)) {

									this.ngZone.run(() => {
										this.usersList[i] = data;
										this.usersList = [].concat(this.usersList);
										//this.usersList[index] = data;
										console.log("  this.usersList", this.usersList)
									})
								}
							}
							console.log("updateuser", data);
						})
					} else {
						this.incorrect = data.MESSAGE;
						this.throwError(data)
					}
				})
				this.E_PASSWORD = "";
				this.E_USERNAME = "";
			}

		});

	}
	manageCompanyPermission = false;
	manageCompanyPermissionMessage = ''
	checkManageCompanyPermission() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 31};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.manageCompanyPermission = false;
			} else {
				this.manageCompanyPermission = true;
			}

			this.manageCompanyPermissionMessage = checkResponse.MESSAGE;

		});
	}
	checkManageCompanyPermissionModal() { // this function just closes modals and throws errors
		if (!this.manageCompanyPermission) {
			this.throwError(this.manageCompanyPermissionMessage);
			setTimeout(() => { $('#companyModal').modal('hide'); }, 250);
		}
	}

	manageGroupsPermission = false;
	manageGroupsPermissionMessage;
	checkManageGroupsPermission() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 46};

		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return;						
			}

			this.manageGroupsPermission = data.USER_PERMISSION == 'Y' ? true : false;
			this.manageGroupsPermissionMessage = data;
		});
	}

	checkManageGroupsPermissionModal(event: Event) {
		this.checkManageGroupsPermission();
	
		if (!this.manageGroupsPermission) {
			this.throwError(this.manageGroupsPermissionMessage);
			event.stopPropagation();
			event.preventDefault();
		} else {
			this.getCompanyGroups();
		}
	}

	manageReportSettingsPermission = false;
	checkManageReportSettingsPermission() {

		this.manageReportSettingsPermission = false;

		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 36};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.manageReportSettingsPermission = false;
			} else {
				this.manageReportSettingsPermission = true;
			}
		});
	}
	showPhone() {
		console.log(this.form.value.clientPhone);
	}
	ngOnInit(): void {
		this.geoCoder = new google.maps.Geocoder;
		this.titleService.setTitle("SCRIVA-Company")
		this.form = this.fb.group({
			companyName: ['', [Validators.required]],
			clientEmail: ['', [Validators.email]],//, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
			// clientPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],
			clientPhone: ['', []],

		});
		this.userform = this.fb.group({
			userEmail: ['', [Validators.email, Validators.required]],//, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
			userPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],
			alternate: ['', [Validators.email]],//, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
		});
		this.settingsCols1 = [
			{ field: '', header: 'Quantity', width: '8%' },
			{ field: '', header: 'Unit', width: '5%' },
			{ field: '', header: 'Unit Cost', width: '5%' },
			{ field: '', header: 'Cycle Replacement', width: '10%' },
			{ field: '', header: 'Replacement Percent', width: '10%' },
			{ field: '', header: 'Immediate Total', width: '8%' },
			{ field: '', header: 'Short Term Total', width: '10%' },
		]
		this.settingsCols2 = [
			{ field: '', header: 'Recommendation', width: '10%' },
			{ field: '', header: 'EUL', width: '5%' },
			{ field: '', header: 'EFF AGE', width: '5%' },
			{ field: '', header: 'RUL', width: '5%' },
			{ field: '', header: 'Year', width: '5%' },
			{ field: '', header: 'Cost', width: '5%' },
		]
		this.locationCols = [
			{ field: 'LOCATION_NAME', header: 'Office Name', width: '10%' },
			{ field: 'FULL_ADDRESS', header: 'Address', width: '20%' },
			{ field: 'HEAD_OFFICE', header: 'Head Office', width: '5%' },
			{ field: 'STATUS', header: 'Status', width: '8%' },
			{ field: 'EDIT', header: 'Action', width: '5%' },
		]
		this.groupCols = [
			{ field: 'GROUP_NAME', header: 'Group Name', width: '35%' },
			//{ field: 'USERS', header: 'Users', width: '25%' },
			{ field: 'STATUS', header: 'Status', width: '8%' },
			{ field: 'EDIT', header: 'Action', width: '5%' },
		];
		this.setContactCols();
		this.setCols()
		this.clientCols = [
			{ field: 'CLIENT_COMPANY_NAME', header: 'Company Name', width: '15%' },
			{ field: 'CLIENT_FULL_ADDRESS', header: 'Company Address', width: '20%' },
			{ field: 'CLIENT_CONTACT_NAME', header: 'Contact Name', width: '15%' },
			{ field: 'CLIENT_CONTACT_TITLE', header: 'Contact Title', width: '10%' },
			{ field: 'CLIENT_CONTACT_EMAIL', header: 'Contact Email', width: '15%' },
			{ field: 'CLIENT_CONTACT_PHONE', header: 'Contact Phone', width: '10%' },
			{ field: 'STATUS', header: 'Status', width: '5%' },
			{ field: 'EDIT', header: 'Edit', width: '5%' },
		]
		this.fileCols = [{ field: 'FILE_NAME', header: 'File Name', width: '15%' }, 
			{ field: 'FILE_DESCRIPTION', header: 'File Description', width: '35%' },
			{ field: 'FILE_TYPE', header: 'File Type', width: '15%' },
			{ field: 'UPDATED_BY', header: 'Uploaded By', width: '15%' },
			{ field: 'DATE_UPDATED', header: 'Uploaded Date', width: '15%' },
			{ field: 'EDIT', header: 'Actions', width: '5%' }
		];
	}

	setCols() {
		this.cols = [
			{ field: 'FIRST_NAME', header: 'First Name', searchField: 'FIRST_NAME',width: '7%' },
			{ field: 'LAST_NAME', header: 'Last Name', searchField: 'LAST_NAME', width: '7%' },
			{ field: 'USER_EMAIL', header: 'Email', searchField: 'USER_EMAIL', width: '14%' },
			{ field: 'PHONE_NUMBER', header: 'Phone Number', searchField: 'PHONE_NUMBER', width: '6%' },
			{ field: 'JOB_TITLE', header: 'Job Title', searchField: 'JOB_TITLE', width: '8%' },
			{ field: 'RESUMES', header: 'Resumes', searchField: 'RESUMES', width: '10%' },
			{ field: 'SIGNATURE_URL', header: 'Signature', searchField: 'SIGNATURE_URL', width: '5%' },
			{ field: 'SEAL_URL', header: 'Seal', searchField: 'SEAL_URL', width: '%' },
			{ field: 'EXTERNAL_USER', header: 'Ext', searchField: 'EXTERNAL_USER', width: '3%' },
			{ field: 'ERIS_USERNAME', header: 'Eris ID', searchField: 'ERIS_USERNAME', width: '5%' },
			{ field: 'ROLE_NAME', header: 'Role', searchField: 'ROLE_NAME', width: '5%' },
			...(this.companyGroupIndicator ? [{ field: 'GROUPS', header: 'Groups', searchField: 'GROUPS', width: '8%' }] : []),
			{ field: 'DATE_CREATED', header: 'Created Date', searchField: 'DATE_CREATED', width: '7%' },
			{ field: 'LAST_LOGIN_DATE', header: 'Last Login',searchField: 'LAST_LOGIN_DATE',  width: '7%' },
			{ field: 'STATUS', header: 'Status', searchField: 'STATUS', width: '4%' },
		];
	}

	setContactCols() {
		this.contactCols = [
			{ field: 'FULL_NAME', header: 'Name', width: '15%' },
			{ field: 'USER_EMAIL', header: 'Email', width: '15%' },
			{ field: 'ALTERNATIVE_EMAIL', header: 'Alternate Email', width: '15%' },
			{ field: 'ROLE_NAME', header: 'Role', width: '15%' },
			...(this.companyGroupIndicator ? [{ field: 'SUPER_ADMIN_USER', header: 'Super Admin', width: '8%' }] : []),
		];
	}

	groupKey;
	/*private getLogo(){
		let inputJson={"PROCEDURE":"getcompanylogo","CUSTOMER_ID":parseInt(this.userId)};
		this.reportService.logouniveralService(inputJson).subscribe(data => {console.log(data);
			
			this.logoInfo=data;
		})
	}*/
	expanded = false;
	expandcollapse() {
		this.expanded = !this.expanded;
	}
	updateRole(data, user) {
		let inputJson = {
			"PROCEDURE": "updaterwuser",
			"USER_ID": parseInt(this.userId),
			"UPDATE_USER_ID": user.USER_ID,
			"ROLE_ID": Number(this.role)
		}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			console.log(data);
		})
	}
	private geoCoder;
	getCords(user) {
		let list = [user.CLIENT_ADDRESS_LINE1, user.CLIENT_ADDRESS_LINE2, user.CLIENT_CITY, user.CLIENT_PROVSTATE, user.CLIENT_POSTALZIP, user.CLIENT_COUNTRY]
		let list1 = []
		for (var i in list) {
			if (list[i] != '') {
				list1.push(list[i])
			}
		}
		//let list=[user.CLIENT_CITY,user.CLIENT_PROVSTATE,user.CLIENT_POSTALZIP];console.log(list)
		let address = user.CLIENT_FULL_ADDRESS;
		//for(let l of list){console.log(l)
		//	if(l.length>0){
		//		address +=','+l;
		//	}
		//}
		let content: any;
		content = { 'address': address };

		//console.log("getAddress", content);
		let that=this
		this.geoCoder.geocode(content, (results, status) => {
			//console.log(results);
			//console.log(status);
			//console.log("valid", list1.length)
			if (status === 'OK' && (results[0].geometry.location_type == "ROOFTOP" || results[0].types == "street_address") && list1.length >= 2) {
				//console.log("valid", results[0].geometry.location_type)
				//console.log("valid", results[0].types)
				if (results[0]) {
					//console.log("geocodedone");
					//this.zoom = 12;
					this.address = results[0].formatted_address; //console.log(this.address);
					this.ngZone.run(() => {
						user.lat = results[0].geometry.location.lat();
						user.long = results[0].geometry.location.lng();
						this.noLocation = true;
						this.zoom = 18;
					})

				} else {
					//  window.alert('No results found');
					user.lat = 48.3552518;
					user.long = -100.0036572;
					this.noLocation = false;
					this.zoom = 3;
					//console.log("valid", results[0].geometry.location_type)
					//console.log("valid", results[0].types)
				}
			} else {
				//window.alert('Geocoder failed due to: ' + status);
				user.lat = 48.3552518;
				user.long = -100.0036572;
				this.noLocation = false;
				this.zoom = 3;
				//console.log("valid", results[0].geometry.location_type)
				//console.log("valid", results[0].types)
			}
			let latLng=new google.maps.LatLng(user.lat, user.long)
		var mapOptions = {
			mapTypeControl:false,
			center: latLng,
			zoom: this.zoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDoubleClickZoom: true,
			mapId: "DEMO_MAP_ID"
		};
		
		setTimeout(() => {
			let ele= document.getElementById("googleMap2") ;
			if(!ele) return
			that.googleMap2 = new google.maps.Map(ele, mapOptions);
			if(!this.noLocation) return
			that.infoWindow2 = new google.maps.InfoWindow({position: latLng, content: '<span style="color:black; font-weight:bold">'+address+'</span>'});
			//that.infoWindow2.open(that.googleMap2);
			let map2=that.googleMap2;
			that.marker2=new google.maps.Marker({
				map: map2,
				icon:'assets/images/Site_Marker.png',
				title: user.FULL_ADDRESS,
				position: { lat: user.lat, lng: user.long },
			})
			that.marker2.addListener("click", () => {
				that.infoWindow2 .open({
				anchor: that.marker2,
				map2,
				});
			});
			
			}, 250);
		});
	}
	googleMap2:google.maps.Map;
	infoWindow2=null;
	marker2:any;
	noLocation = true;
	zoom = 18;
	getCords1(user) {
		let list = [user.ADDRESS_LINE1, user.ADDRESS_LINE2, user.CITY, user.PROVSTATE, user.POSTALZIP, user.COUNTRY]
		let list1 = []
		for (var i in list) {
			if (list[i] != '') {
				list1.push(list[i])
			}
		}
		let address = user.FULL_ADDRESS
		let content: any;
		content = { 'address': address };

		//console.log("getAddress", content);
		let that=this;
		this.geoCoder.geocode(content, (results, status) => {
			//console.log(results);
			//console.log(status);
			//console.log("valid", list1.length)
			if (status === 'OK' && (results[0].geometry.location_type == "ROOFTOP" || results[0].types == "street_address") && list1.length >= 2) {
				//console.log("valid", results[0].geometry.location_type)
				//console.log("valid", results[0].types)
				if (results[0]) {
					//console.log("geocodedone");
					//this.zoom = 12;
					this.address = results[0].formatted_address; //console.log(this.address);
					this.ngZone.run(() => {
						user.lat = results[0].geometry.location.lat();
						user.long = results[0].geometry.location.lng();
						this.noLocation = true;
						this.zoom = 18;

					})

				} else {
					//  window.alert('No results found');
					user.lat = 48.3552518;
					user.long = -100.0036572;
					this.noLocation = false;
					this.zoom = 3;
				}
			} else {
				//window.alert('Geocoder failed due to: ' + status);
				user.lat = 48.3552518;
				user.long = -100.0036572;
				this.noLocation = false;
				this.zoom = 3;
			}
			let latLng=new google.maps.LatLng(user.lat, user.long)
		var mapOptions = {
			mapTypeControl:false,
			center: latLng,
			zoom: this.zoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDoubleClickZoom: true,
			mapId: "DEMO_MAP_ID"
		};
		
		setTimeout(() => {
			let ele= document.getElementById("googleMap2") ;
			if(!ele) return
			that.googleMap2 = new google.maps.Map(ele, mapOptions);
			that.infoWindow2 = new google.maps.InfoWindow({position: latLng, content: '<span style="color:black; font-weight:bold">'+user.FULL_ADDRESS+'</span>'});
			//that.infoWindow2.open(that.googleMap2);
			if(!this.noLocation) return
			let map2=that.googleMap2;
		that.marker2=new google.maps.Marker({
			map: map2,
			icon:'assets/images/Site_Marker.png',
			title: user.FULL_ADDRESS,
			position: { lat: user.lat, lng: user.long },
		})
		that.marker2.addListener("click", () => {
			that.infoWindow2 .open({
			  anchor: that.marker2,
			  map2,
			});
		  });
		
		}, 250);
		});
		
		
		
	}
	onHide(){
		if (this.infoWindow2 !== null){
			this.infoWindow2.setMap(null);
			this.infoWindow2=null;
		} 	
		if (this.marker2 !== null){
			this.marker2.setMap(null);
			this.marker2=null;
		} 	
		this.googleMap2=null;
	}
	userInfo;
	logoInfo;
	getUserDetail() {
		if (this.cookieService.getCookie("userID")) {

			this.userInfo = JSON.parse(this.cookieService.getCookie("userInfo"));
			console.log("firstuserinfo", this.userInfo)
			this.userId = this.cookieService.getCookie("userID"); console.log(this.userId);
			// this.userInfo=this.cookieService.getCookie("userInfo");
			// this.userId = this.cookieService.getCookie("userID");console.log(this.userId);
			// this.r = this.cookieService.getCookie("r");
			this.getCompanyInfo();
			this.getSignStyles(); this.getSignRoles(); this.getAlignments();
			this.userName = this.cookieService.getCookie("userName"); console.log(this.userName);

			this.checkManageCompanyPermission();
			this.checkManageReportSettingsPermission();
			this.checkManageGroupsPermission();
			this.getDateFormat();
			this.getCompanyProfiles();
			this.getSignStyles(); 
			this.getSignRoles(); 
			this.getAlignments();
			//this.getLogo();
			// this.getClientsByCompany();
			// this.getData();
			// this.getAllTemplate(this.userId);
			// this.getAllCover(this.userId);
			// //this.getAllReport(this.userId);
			// //this.getAllReportByGroup("PROJECT_ID");
			// this.getAllReportByGroup("PROJECT_NUMBER");
			// this.getTitles();
			// this.getStatus(-1);
			// this.getAllType(this.userId);
			// this.getAllCode(this.userId);
			// this.getAllTemplateCategory(this.userId);
			// this.getAllClientInfo(this.userId);
			// this.getAllReportUsers(-1, -1); // For testing only
			// this.getAllTempBySubCat(this.userId, "Environmental"); // For testing only
			// this.getAllTempByTypeID(this.userId, 23); // For testing only
			//this.getAllUser(this.userId);
			//this.getAllStatus(this.userId);
			//this.es.currentUser=this.cookieService.getCookie("userName");
			// this.getLogo();
			
			// this.getUserInfo();
		} else {
			this.userId = null;
		}
	}
	getUserInfo() {
		console.log(this.userInfo);
		let inputJson = { "PROCEDURE": "getrwuser", "USER_ID": parseInt(this.userInfo.USER_ID), "REQUESTED_USER_ID": parseInt(this.userInfo.USER_ID) }
		console.log("getuserinfo", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("userinfo", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.userInfo = data;
		})
	}
	public onInfo(e) {
		this.getUserDetail();
	}
	getCompanyInfo() {
		this.changedSettings = {}
		let inputJson = { "PROCEDURE": "getcompanyinfo", "USER_ID": parseInt(this.userId) };
		console.log("getCompanyInfo", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("CompanyInfo", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.companyInfo = data;
			const pSettings = data.RW_PROFILE_SETTINGS[0];
			if (pSettings) {
				//this.profileQuestions = { ...this.profileQuestionsDefault, ...this.reportSettingsDefault, ...pSettings }
				this.profileQuestions = JSON.parse(JSON.stringify(pSettings));
				if (pSettings.TOC_STYLE) {
					this.profileQuestions.TOC_STYLE_ID = pSettings.TOC_STYLE.TOC_STYLE_ID;
				}
				if (pSettings.DATE_FORMAT) {
					this.profileQuestions.DATE_FORMAT_ID = pSettings.DATE_FORMAT.DATE_FORMAT_ID;
				}
				if(pSettings.TOC_HEADER){
					this.profileQuestions.TOC_HEADER_ID = pSettings.TOC_HEADER.TOC_HEADER_ID;
				}
				if(pSettings.TOC_FOOTER){
					this.profileQuestions.TOC_FOOTER_ID = pSettings.TOC_FOOTER.TOC_FOOTER_ID;
				}
				this.bodyHeadCss = atob(pSettings.REPORT_BODY_HEAD);
			}else{
				this.createNewProfile();
			}
			console.log(this.profileQuestions);
			for (let i = 0; i < this.companyInfo.RW_LOCATIONS.length; i++) {
				if (this.companyInfo.RW_LOCATIONS[i].HEAD_OFFICE == 'Y') {
					let item = this.companyInfo.RW_LOCATIONS[i];
					this.companyInfo.RW_LOCATIONS.splice(i, 1);
					this.companyInfo.RW_LOCATIONS.unshift(item);
				}
			}
			console.log("CompanyInfo", data);
			this.getCords1(data);
			//this.companyInfo.RW_LOCATIONS.sort(function(x,y){ return x.HEAD_OFFICE == 'Y' ? -1 :  y.HEAD_OFFICE == 'Y' ? 1 : 0; });
			if(pSettings.DEFAULT_SIGNATURE_STYLE){
				this.selectedSign=JSON.parse(JSON.stringify(pSettings.DEFAULT_SIGNATURE_STYLE));
			}
		});

		inputJson.PROCEDURE = "getcompanyprofile";
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}

			this.companyGroupIndicator = data.COMPANY_GROUP_IND === 'Y' ? true : false;
			
			this.setContactCols();
			this.setCols();
		});

		inputJson.PROCEDURE = "getwatermarks";
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.watermarks = data.RW_WATERMARKS;
			console.log("watermarks", this.watermarks);
		});
		
		inputJson.PROCEDURE="getallheaders";
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			}else{
				this.headers=data.RW_HEADERS;console.log('headers', this.headers)
			}			
		})		
		inputJson.PROCEDURE="getallfooters";
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			}else{
				this.footers=data.RW_FOOTERS; console.log('footers',this.footers)
			 }
		})
		
		inputJson.PROCEDURE = "getalltocstyles";
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.tocstyles = data.TOC_STYLES;
			for (let i in this.tocstyles) {
				this.tocstyles[i].src = this.tocstyles[i].TOC_IMAGE_URL;
				this.tocstyles[i].thumb = this.tocstyles[i].TOC_IMAGE_URL;
				this.tocstyles[i].caption = this.tocstyles[i].TOC_FILENAME;
			}
			console.log("tocstyles", this.tocstyles);
		});
		inputJson.PROCEDURE = "getcompanyfiles";
		inputJson["FILE_TYPE"] = "LOGO";
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.logoFiles = data.RW_UPLOAD_FILES;
			console.log("logoFiles", this.logoFiles);
		});
	}

	totalClients = 0
	clientsLoading = false
	getClientsByCompany() {
		if (!this.companyClients) {
			let inputJson = { "PROCEDURE": "getclientsbycompany", "USER_ID": parseInt(this.userId) };
			console.log("getClientsByCompany", inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log("ClientsByCompany", data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				this.clientsLoading = true
				this.companyClients = data.RW_CLIENTS;
				this.totalClients = 0
				console.log(this.clientsLoading)
				for (let user of this.companyClients) {
					this.getCords(user)
					this.totalClients++
				}
				this.clientsLoading = false
			});
		} else {
			let inputJson = { "PROCEDURE": "getclientsbycompany", "USER_ID": parseInt(this.userId) };
			console.log("getClientsByCompany", inputJson)
			this.totalClients = 0
			for (let user of this.companyClients) {
				this.getCords(user)
				this.totalClients++
			}
		}
	}
	consoleLog(item){
		console.log(item)
		//console.log(this.usersList)
	}
	totalUsers = 0;
	usersLoading = false
	usersListCached
	getAllReportUsers() {
		//if (!this.usersList) {
		let inputJson = { "PROCEDURE": "getcompanyuserlist", "USER_ID": parseInt(this.userId), "INCLUDE_EXTERNAL": "Y" }; // hardcoded for now 
		// let usersList=[];
		this.usersList = [];
		this.usersLoading = true
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.usersLoading = false
			console.log("usersList", data);
			// for (let user of data.RW_USERS) {
			// 	this.usersList.push(user);
			// 	// this.usersList=[...this.usersList,user];
			// }
			this.usersListCached = data.RW_USERS
			this.usersList = this.usersListCached; //console.log("userlist", this.usersList);
			if(this.companyGroupIndicator){
				for(let user of this.usersList ){
					user['groupnames']='';
					if(user.GROUPS.length>0){
						user['groupnames']=user.GROUPS[0]['GROUP_NAME'];
						for(let i=1; i<user.GROUPS.length;i++ ){
							user['groupnames']+=','+user.GROUPS[i]['GROUP_NAME'];
						}
					}					
				}
			}
			this.totalUsers = this.usersList.length;
		});

		//}else{
		//	let inputJson = { "PROCEDURE": "getcompanyuserlist", "USER_ID": parseInt(this.userId), "INCLUDE_EXTERNAL": "Y" }; 
		//		this.totalUsers = 0
		//		for(var index in this.usersList){
		//			this.totalUsers++
		//		}
		//}
	}
	allFormat=[];
	getDateFormat(){
		let inputJson={"PROCEDURE":"getdateformats","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			console.log("Date Format", data);
			this.allFormat=data.DATE_FORMAT_LIST;
		});
	}
	portToggle() {
		console.log(this.includeExternal);
		if (this.includeExternal) {

			this.includeExternal = false;
			this.external = "N"
		} else {
			this.includeExternal = true;
			this.external = "Y";
		}
	}
	clientAddress;
	clientAddress2;
	clientState;
	clientCountry;
	clientZip;
	clientCity;
	resetClientForm() {
		this.companyName = "";
		this.address = "";
		this.contactName = "";
		this.contactTitle = "";
		this.clientAddress = "";
		this.clientAddress2 = "";
		this.clientState = "";
		this.clientCountry = "";
		this.clientZip = "";
		this.clientCity = "";
		this.form.reset();
	}
	fillClient(user) {
		this.resetClientForm();
		console.log("fillclient", user);
		this.companyName = user.CLIENT_COMPANY_NAME;
		this.clientAddress = user.CLIENT_ADDRESS_LINE1;
		this.clientAddress2 = user.CLIENT_ADDRESS_LINE2;
		this.clientState = user.CLIENT_PROVSTATE;
		this.clientCountry = user.CLIENT_COUNTRY;
		this.clientZip = user.CLIENT_POSTALZIP;;
		this.clientCity = user.CLIENT_CITY;;
		this.contactName = user.CLIENT_CONTACT_NAME;
		this.contactTitle = user.CLIENT_CONTACT_TITLE;
		this.form.patchValue({ companyName: user["CLIENT_COMPANY_NAME"] });
		this.form.patchValue({ clientEmail: user["CLIENT_CONTACT_EMAIL"] });
		this.form.patchValue({ clientPhone: user["CLIENT_CONTACT_PHONE"] });
	}

	companyName;
	address;
	contactName;
	contactTitle:string;
	addClient() {
		let inputJson = {
			"PROCEDURE": "insertcompanyclient", "USER_ID": parseInt(this.userId), "COMPANY_NAME": this.form.value.companyName, "ADDRESS_LINE1": this.clientAddress,
			"ADDRESS_LINE2": this.clientAddress2, "PROVSTATE": this.clientState, "POSTALZIP": this.clientZip, "CITY": this.clientCity, "COUNTRY": this.clientCountry
			, "CONTACT_NAME": this.contactName, "CONTACT_TITLE": this.contactTitle, "CONTACT_PHONE": this.form.value.clientPhone ? this.form.value.clientPhone.toString() : null, "CONTACT_EMAIL": this.form.value.clientEmail
		};
		console.log("addClient", inputJson);
		// this.companyName = "";
		// this.address = "";
		// this.contactName = "";
		// this.form.reset();
		$('#reportsModal').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.getCords(data);
			this.companyClients = [data, ...this.companyClients];
			console.log("  this.companyClients", this.companyClients)
			this.resetClientForm();
			this.getClientsByCompany();
		});
	}
	curRptPara = {
		'RESUME': { "FILE_URL": "" },
		'SIGNATURE': {},
		'name': 'Choose File',
	};
	curRptPara2 = {
		'RESUME': { "FILE_URL": "" },
		'SIGNATURE': {},
		'name': 'Choose File',
	};

	resetUserForm() {
		this.role = 2
		this.roles = this.companyRolesHolder
		this.inviteUserWarn = false
		this.firstname = ""
		this.lastname = ""
		this.jobTitle = ""
		this.userExternal = "";
		this.errId='';
		this.userform.reset();
		this.curRptPara = {
			'RESUME': { "FILE_URL": "" },
			'SIGNATURE': {},
			'name': 'Choose File',
		};
		this.curRptPara2 = {
			'RESUME': { "FILE_URL": "" },
			'SIGNATURE': {},
			'name': 'Choose File',
		};
	}
	phoneNumberValid = true
	phonenumber
	fillUser(user) {

		this.resetUserForm();
		console.log("filluser", user);
		this.firstname = user.FIRST_NAME;
		this.lastname = user.LAST_NAME
		this.jobTitle = user.JOB_TITLE
		this.errId=user.BATCH_LOAD_ID;
		if (typeof user.ROLE_ID === 'undefined' || user.ROLE_ID === null) {
			// variable is undefined or null
			this.role = -1;
		} else {
			this.role = user.ROLE_ID;
		}
		this.phonenumber = user.PHONE_NUMBER
		this.userExternal = user.EXTERNAL_USER == "Y"
		this.userform.patchValue({ alternate: user["ALTERNATIVE_EMAIL"] });
		if (user["PHONE_NUMBER"].length > 0) {
			//console.log('true')
			this.userform.patchValue({ userPhone: parseInt(user["PHONE_NUMBER"]) });
			console.log(this.userform.status)
			// if(this.userform.status=='VALID'){
			// 	console.log(true)
			// 	this.phoneNumberValid = true
			// } 
			// else if(this.userform.status=='INVALID'){
			// 	this.phoneNumberValid = false
			// 	console.log(false)
			// } 
		}
		//this.phoneNumber = this.phoneForm(user.PHONE_NUMBER)
		this.userform.patchValue({ userEmail: user["USER_EMAIL"] });
	}
	fillCompany(location) {
		this.companyAddress1 = location.ADDRESS_LINE1;
		this.companyAddress2 = location.ADDRESS_LINE2;
		this.companyState = location.PROVSTATE;
		this.companyZip = location.POSTALZIP;
		this.companyCount = location.COUNTRY
		this.companyCity = location.CITY
		this.headOffice = location.HEAD_OFFICE == "Y";
		this.status = location.STATUS
		this.companyAddress = location.FULL_ADDRESS
		this.locationName = location.LOCATION_NAME
		this.companyERIS = location.ERIS_BRANCH_ID?location.ERIS_BRANCH_ID:'';
	}
	fillGroup(group) {
		let inputGroupJson = {
			"PROCEDURE": "getuserlistforgroup",
			"USER_ID": parseInt(this.userId),
			"GROUP_ID": group.GROUP_ID
		};
		
		this.reportService.univeralService(JSON.stringify(inputGroupJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data);
				return;
			}

			// only require user id, full name and email for groups tab
			group.USERS = data.GROUP_USERS.map(user => ({
				USER_ID: user.USER_ID,
				USER_EMAIL: user.USER_EMAIL,
				FULL_NAME: user.FULL_NAME
			}));

			this.inputGroupName = group.GROUP_NAME;
			this.inputGroupUsers = group.USERS;
		});
	}
	headChange(location) {
		console.log(location)
		let inputJson;
		if (location.HEAD_OFFICE == "Y") {
			location.HEAD_OFFICE = "N"
			inputJson = { "PROCEDURE": "updaterwlocation", "USER_ID": parseInt(this.userId), "LOCATION_ID": location.LOCATION_ID };
		} else {
			location.HEAD_OFFICE = "Y"
			inputJson = { "PROCEDURE": "updaterwlocation", "USER_ID": parseInt(this.userId), "LOCATION_ID": location.LOCATION_ID }

		}
		location.HEAD_OFFICE = location.HEAD_OFFICE == "HEAD" ? "N" : "Y";
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			console.log(data)
		});
	}
	clearCompanyLocation() {
		this.companyAddress1 = "";
		this.companyAddress2 = "";
		this.companyState = "";
		this.companyZip = "";
		this.companyCount = ""
		this.companyCity = ""
		this.status = ''
		this.companyAddress = ''
		this.headOffice = false
		this.locationName = '';
		this.companyERIS = "";
	}
	clearGroup() {
		this.inputGroupID = null;
		this.inputGroupName = "";
		this.inputGroupSelectedUser = null;
		this.inputGroupUsers = [];
	}
	onEditReport(e) {

	}
	show2(stuff) {
		console.log(stuff);
		return false;
	}

	manageUsersPermission = false;
	checkManageUsersPermission(edit_user_id) {
		this.manageUsersPermission = false;

		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 32};
		if (edit_user_id !== null) {
			checkUserInputJson['EDIT_USER_ID'] = edit_user_id
		}
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.manageUsersPermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way 
				setTimeout(() => { $('#reportsModal2').modal('hide'); }, 250);
			} else {
				this.manageUsersPermission = true;
			}

		});
	}
	firstname;
	lastname;
	jobTitle;
	userExternal;
	errId;
	addUser() {
		let inputJson = {
			"PROCEDURE": "insertrwuser", "USER_ID": parseInt(this.userId), "USER_EMAIL": this.userform.value.userEmail.lowercase, "ALTERNATIVE_EMAIL": this.userform.value.alternate,
			"ERIS_USER_ID": null, "PASSWORD": "", "FIRST_NAME": this.firstname, "LAST_NAME": this.lastname, "JOB_TITLE": this.jobTitle, "ROLE_ID": this.role, "EXTERNAL_USER": this.userExternal ? "Active" : "Inactive", "PHONE_NUMBER": this.userform.value.userPhone ? this.userform.value.userPhone.toString() : null,
			"SIGNATURE_URL": this.curRptPara2.RESUME.FILE_URL
		}
		//let inputJson2 = { "PROCEDURE": "insertuserresume", "USER_ID": parseInt(this.userId), "RESUME_FILENAME": this.curRptPara.name, "RESUME_TITLE": this.curRptPara.name, "RESUME_URL": this.curRptPara.RESUME.FILE_URL }

		console.log("adduser", inputJson)

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			//	inputJson2["RESUME_USER_ID"] = data.USER_ID;
			//	console.log(inputJson2);
			// this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data2 => {
			// 	console.log(data2);
			// 	data.RESUMES.push(data2);

			// });
			if (data.RESPONSE_STATUS == 'N') {
				let info={'MESSAGE':'Login Failed'};
				this.throwError(info);
			} else {
				this.firstname = ""
				this.lastname = ""
				this.jobTitle = ""
				this.userExternal = ""
				this.role = 2;
				this.errId='';
				this.userform.reset();
				$('#reportsModal2').modal('hide');
				this.ngZone.run(() => {
					this.usersList = [data, ...this.usersList];
					console.log("  this.usersList", this.usersList)
				})
			}
		});
		console.log(inputJson)
	}

	changeUser(index) {
		this.inviteUserWarn = false
		if(this.firstname == ''){
			this.inviteUserWarn = true
			this.inviteUserWarnMessage = "First and Last Name are required"
		}
		if(this.lastname == ''){
			this.inviteUserWarn = true
			this.inviteUserWarnMessage = "First and Last Name are required"
		}
		if(this.role == -1){
			this.inviteUserWarn = true
			this.inviteUserWarnMessage = "Role is required"
		}
		if(this.inviteUserWarn!=true){
			let inputJson = {
				"PROCEDURE": "updaterwuser", "USER_ID": parseInt(this.userId), "UPDATE_USER_ID": this.userEditId, "USER_EMAIL": this.userform.value.userEmail, "ALTERNATIVE_EMAIL": this.userform.value.alternate,
				"FIRST_NAME": this.firstname, "LAST_NAME": this.lastname, "JOB_TITLE": this.jobTitle, "ROLE_ID": Number(this.role), "EXTERNAL_USER": this.userExternal ? "Y" : "N", "PHONE_NUMBER": this.userform.value.userPhone ? this.userform.value.userPhone.toString() : null,

			}
			//.ALTERNATE_EMAIL.let inputJson2 = { "PROCEDURE": "insertuserresume", "USER_ID": parseInt(this.userId), "RESUME_FILENAME": this.curRptPara.name, "RESUME_TITLE": this.curRptPara.name, "RESUME_URL": this.curRptPara.RESUME.FILE_URL }

			console.log("changeUser", inputJson)

			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				// this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data2 => {
				// 	console.log(data2);
				// 	data.RESUMES.push(data2);
				let copy = [...this.usersList];

				// });
				for (let i = 0; i < this.usersList.length; i++) {
					if (this.usersList[i].USER_ID == this.userEditId) {
						copy[i] = data;
						this.ngZone.run(() => {
							this.usersList = [...copy]
							//this.usersList[index] = data;
							console.log("  this.usersList", this.usersList)
						})
					}
				}
				this.firstname = ""
				this.lastname = ""
				this.jobTitle = ""
				this.userExternal = "";
				this.errId='';
				this.userform.reset();
				$('#reportsModal2').modal('hide');
			});
		}
		//console.log(inputJson)
	}
	public uploadFile() {
		let that = this;
		// $('#inputWarn').css('display', 'none');
		$('#inputSuccess').css('display', 'none');
		const file = this.resume.nativeElement.files[0]; console.log(file);
		if (!file) {
			$('#inputWarn').css('display', 'inline-block');
			return
		}
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		$('#spinner').css('display', 'inline-block');
		/*const ext = file.name.replace(/.+\./, '');
		if (['png','PNG', 'jpg','JPG', 'jpeg','JPEG', 'gif','GIF'].indexOf(ext) === -1) {
			Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg|.gif', 'error');
			return;
		}*/
		//this.fileReader.readAsDataURL(file);
		let reader = new FileReader();
		reader.onloadend = function (e) {
			let data = e.target.result.toString().split(',')[1];; console.log(data)
			let inputJson = { "filename": file.name, "fdata": data }
			that.reportService.uploadFile2(inputJson).subscribe(result => {
				console.log("result", result);
				if (result.RESPONSE_STATUS=='N') {
					that.throwError(result);
					return										
				}
				that.curRptPara.RESUME = result; console.log("RESUME", that.curRptPara.RESUME);
				that.resume.nativeElement.value = null;
				$('#spinner').css('display', 'none');
				$('#inputSuccess').css('display', 'inline-block');
				// that.curRptPara.name='Choose File';
			})
			//.error
		}
		reader.readAsDataURL(file);

	}
	public uploadFile2() {
		let that = this;
		// $('#inputWarn').css('display', 'none');
		$('#inputSuccess2').css('display', 'none');
		const file = this.signature.nativeElement.files[0]; console.log(file)
		if (!file) {
			$('#inputWarn').css('display', 'inline-block');
			return
		}
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		$('#spinner2').css('display', 'inline-block');
		/*const ext = file.name.replace(/.+\./, '');
		if (['png','PNG', 'jpg','JPG', 'jpeg','JPEG', 'gif','GIF'].indexOf(ext) === -1) {
			Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg|.gif', 'error');
			return;
		}*/
		//this.fileReader.readAsDataURL(file);
		let reader = new FileReader();
		reader.onloadend = function (e) {
			let data = e.target.result.toString().split(',')[1];; console.log(data)//upload service
			//let inputJson={"filename":file.name,"customerid":that.userId,"Order":'123',"reportID":'123','r':'123',"fdata":data}; console.log(inputJson)
			let inputJson = { "filename": file.name, "fdata": data }
			that.reportService.uploadFile2(inputJson).subscribe(result => {
				console.log("result", result);
				if (result.RESPONSE_STATUS=='N') {
					that.throwError(result);
					return										
				}
				that.curRptPara2.RESUME = result; console.log("RESUME", that.curRptPara2.RESUME);
				that.signature.nativeElement.value = null;
				$('#spinner2').css('display', 'none');
				$('#inputSuccess2').css('display', 'inline-block');
				that.curRptPara2.name = 'Choose File';
			})
			//.error
		}
		reader.readAsDataURL(file);

	}
	upload3FileType
	public uploadFile3(callback) {
		let that = this;
		// $('#inputWarn').css('display', 'none');
		$('#inputSuccess2').css('display', 'none');
		const file = this.signature.nativeElement.files[0]; console.log(file)
		if (!file) {
			$('#inputWarn').css('display', 'inline-block');
			return
		}
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		$('#spinner2').css('display', 'inline-block');
		/*const ext = file.name.replace(/.+\./, '');
		if (['png','PNG', 'jpg','JPG', 'jpeg','JPEG', 'gif','GIF'].indexOf(ext) === -1) {
			Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg|.gif', 'error');
			return;
		}*/
		//this.fileReader.readAsDataURL(file);
		let reader = new FileReader();
		reader.onloadend = function (e) {
			let data = e.target.result.toString().split(',')[1];; console.log(data)//upload service
			//let inputJson={"filename":file.name,"customerid":that.userId,"Order":'123',"reportID":'123','r':'123',"fdata":data}; console.log(inputJson)
			let inputJson = { "filename": file.name, "fdata": data, "user_id": parseInt(that.userId), 'file_type': that.upload3FileType }
			that.reportService.uploadFile2(inputJson).subscribe(result => {
				console.log("result", result);
				if (result.RESPONSE_STATUS=='N') {
					that.throwError(result);
					return										
				}
				that.curRptPara2.RESUME = result; console.log("RESUME", that.curRptPara2.RESUME);
				that.signature.nativeElement.value = null;
				$('#spinner2').css('display', 'none');
				$('#inputSuccess2').css('display', 'inline-block');
				that.curRptPara2.name = 'Choose File';
				callback();
			})
			//.error
		}
		reader.readAsDataURL(file);

	}

	changeRolesList() {
		if (this.userExternal) {
			this.roles = this.companyRolesHolder.filter(role => role.ROLE_TYPE === "EXTERNAL")
		} else {
			this.roles = this.companyRolesHolder.filter(role => role.ROLE_TYPE === "INTERNAL")
		}
	}

	changeRole() {
		this.changeRolesList();
		this.role = this.roles.find(role => role.DEFAULT_ROLE_TYPE === "Y").ROLE_ID
	}

	selectFile() {
		this.resume.nativeElement.click();
	}
	getName() {
		this.curRptPara.name = this.resume.nativeElement.files[0].name;
	}

	selectFile2() {
		this.signature.nativeElement.click();
	}
	getName2() {
		this.curRptPara2.name = this.signature.nativeElement.files[0].name;
	}
	userview = false;
	toggleUser() {
		this.userview = !this.userview;
	}
	clientview = false;
	toggleClient() {
		this.clientview = !this.clientview;
	}
	inviteUserLoading = false
	inviteUserWarn
	inviteUserWarnMessage = ""
	inviteUser() {
		this.inviteUserWarn = false
		if(this.firstname == ''){
			this.inviteUserWarn = true
			this.inviteUserWarnMessage = "First and Last Name are required"
		}
		if(this.lastname == ''){
			this.inviteUserWarn = true
			this.inviteUserWarnMessage = "First and Last Name are required"
		}
		if(this.role == -1){
			this.inviteUserWarn = true
			this.inviteUserWarnMessage = "Role is required"
		}
		if(this.inviteUserWarn!=true){
		let inputJson = {
			"PROCEDURE": "inviterwuserv2", "USER_ID": parseInt(this.userId), "USER_EMAIL": this.userform.value.userEmail,
			"ALTERNATIVE_EMAIL": this.userform.value.alternate,
			"FIRST_NAME": this.firstname, "LAST_NAME": this.lastname,
			"JOB_TITLE": this.jobTitle,
			"ROLE_ID": Number(this.role),
			"EXTERNAL_USER": this.userExternal ? "Y" : "N",
			"PHONE_NUMBER": this.userform.value.userPhone ? this.userform.value.userPhone.toString() : null,
			"SIGNATURE_URL": this.curRptPara2.RESUME.FILE_URL
		}
		if(this.errId){
			inputJson['BATCH_LOAD_ID']=this.errId;
		}
		
		this.inviteUserLoading = true
		console.log("inviteUser", inputJson);

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("inviteUser", data);
			this.inviteUserLoading = false
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}else{
				if(this.errId){
					let index=this.usersList.findIndex(user=>user.BATCH_LOAD_ID==this.errId);
					if(index>-1){
						this.usersList.splice(index, 1);
					}
				}
				//console.log('here to remove this item')
			}
			

			//let data={'USER_ID':data2.USER_ID, "USER_EMAIL": this.userform.value.userEmail, "RESUMES":[], "SIGNATURE_URL":'', 'STATUS':"Active", "EXTERNAL_USER":this.userExternal ? "Y" : "N"}
			this.firstname = ""
			this.lastname = ""
			this.jobTitle = ""
			this.userExternal = "";
			this.errId='';
			this.userform.reset();

			$('#reportsModal2').modal('hide');

			// if (data.RESPONSE_STATUS == "Y" && this.companyUsersBounded) {
			if (data.RESPONSE_STATUS == "Y") {
				this.ngZone.run(() => {
					this.usersListCached = [data, ...this.usersListCached];
					if (this.companyUsersBounded) {
						this.usersList = this.usersListCached;
					}
					console.log("  this.usersList", this.usersList)
					// console.log("  this.usersListCached", this.usersListCached)
					//this.getAllReportUsers();
					this.totalUsers = this.usersList.length;
				})
				Swal.fire({
					title: data.MESSAGE,
			})

			} 
			
		})
	}
	}

	changeSignature(file, user) {

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "EDIT_USER_ID": user.USER_ID, "FUNCTION_ID": 32};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				this.upload3FileType = 'USER_SIGNATURE'

				if (file != null) {
					this.uploadFile3(() => {
						user.SIGNATURE_URL = this.curRptPara2.RESUME.FILE_URL;
						let inputJson = { "PROCEDURE": "updaterwuser", "USER_ID": parseInt(this.userId), "UPDATE_USER_ID": user.USER_ID, "SIGNATURE_URL": this.curRptPara2.RESUME.FILE_URL }
						console.log(inputJson);
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
							console.log(data)
							if (data.RESPONSE_STATUS == 'N') {
								this.throwError(data);
							}
						});
					});
				} else {
					let inputJson = { "PROCEDURE": "updaterwuser", "UPDATE_USER_ID": user.USER_ID, "USER_ID": parseInt(this.userId), "SIGNATURE_URL": "" }
					user.SIGNATURE_URL = "";
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						console.log("delete signature", data)
						if (data.RESPONSE_STATUS == 'N') {
							this.throwError(data);
						}
					});
				}
				this.curRptPara2 = {
					'RESUME': { "FILE_URL": "" },
					'SIGNATURE': {},
					'name': 'Choose File',
				};
				
			}

		});

		
	}
	fileType = true;
	checkFile(file) {
		if (file.search('png')) {
			this.fileType = true
		} else {
			this.fileType = false
		}
	}
	changeSeal(file, user) {
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "EDIT_USER_ID":user.USER_ID, "FUNCTION_ID": 32};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				this.upload3FileType = 'USER_SEAL'

				if (file != null) {
					this.uploadFile3(() => {
						user.SEAL_URL = this.curRptPara2.RESUME.FILE_URL;
						let inputJson = { "PROCEDURE": "updaterwuser", "USER_ID": parseInt(this.userId), "UPDATE_USER_ID": user.USER_ID, "SEAL_URL": this.curRptPara2.RESUME.FILE_URL }
						console.log(inputJson);
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
							console.log(data)
							if (data.RESPONSE_STATUS == 'N') {
								this.throwError(data);
							}
						});
					});
				} else {
					let inputJson = { "PROCEDURE": "updaterwuser", "UPDATE_USER_ID": user.USER_ID, "USER_ID": parseInt(this.userId), "SEAL_URL": "" }
					user.SEAL_URL = "";
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						console.log("delete signature", data)
						if (data.RESPONSE_STATUS == 'N') {
							this.throwError(data);
						}
					});

				}
				this.curRptPara2 = {
					'RESUME': { "FILE_URL": "" },
					'SIGNATURE': {},
					'name': 'Choose File',
				};
				
			}

		});

	}
	resetTableFilters(pt) {
		pt.filter('', 'STATUS', 'contains'); pt.filter('', 'EXTERNAL_USER', 'equals');
	}
	loading;
	clientRemoveIndex;
	groupkey;
	manageClientPermission = false;
	checkManageClientPermission() {

		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 42};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse);
				// close the modal. the timeout is to give it time to load. very hacky, find a better way
				this.manageClientPermission = false;
				setTimeout(() => { $('#reportsModal').modal('hide'); }, 500);
			} else {
				this.manageClientPermission = true;
			}

		});

	}
	changeClient() {
		let inputJson = {
			"PROCEDURE": "updateclient", "USER_ID": parseInt(this.userId), "CLIENT_ID": this.clientId, "COMPANY_NAME": this.form.value.companyName, "ADDRESS_LINE1": this.clientAddress,
			"ADDRESS_LINE2": this.clientAddress2, "PROVSTATE": this.clientState, "POSTALZIP": this.clientZip, "CITY": this.clientCity, "COUNTRY": this.clientCountry
			, "CONTACT_NAME": this.contactName, "CONTACT_TITLE": this.contactTitle, "CONTACT_PHONE": this.form.value.clientPhone ? this.form.value.clientPhone.toString() : null, "CONTACT_EMAIL": this.form.value.clientEmail
		};
		console.log("changecliehnt", inputJson)
		$('#reportsModal').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data)
			// this.companyClients[this.clientRemoveIndex]=data;
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.getCords(data)

			for (let i = 0; i < this.companyClients.length; i++) {
				if (this.companyClients[i].CLIENT_ID == this.clientId) {
					this.companyClients[i] = data;
					this.companyClients = [].concat(this.companyClients);
				}
			}
			//	this.companyClients = [].concat(this.companyClients);
			console.log(this.companyClients)
			//this.ref.detectChanges();
			console.log(this.companyClients[this.clientRemoveIndex])
		});
	}
	deleteClient(client, i) {
		if (!this.manageCompanyPermission) {
			let info={'MESSAGE':this.manageCompanyPermissionMessage};
			this.throwError(info);
		} else {
			for (let i = 0; i < this.companyClients.length; i++) {
				if (this.companyClients[i].CLIENT_ID == client.CLIENT_ID) {
					this.ngZone.run(() => {
						this.companyClients.splice(i, 1);
					})
				}
			}
			let inputJson = { "PROCEDURE": "deleteclientfromcompany", "CLIENT_ID": client.CLIENT_ID, "USER_ID": parseInt(this.userId) }
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
													
				}
			});
		}
	}
	changeClientStatus(user) {
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 42};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				console.log(user)
				let inputJson;
				if (user.STATUS == "Active") {
					inputJson = { "PROCEDURE": "removerwclient", "USER_ID": parseInt(this.userId), "CLIENT_ID": user.CLIENT_ID }
				} else {
					inputJson = { "PROCEDURE": "activaterwclient", "USER_ID": parseInt(this.userId), "CLIENT_ID": user.CLIENT_ID }
				}

				user.STATUS = user.STATUS == "Active" ? "Inactive" : "Active";
				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data)
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
														
					}
				});
			}

		});

	}
	changeStatus(user) {
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "EDIT_USER_ID":user.USER_ID, "FUNCTION_ID": 32};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				console.log(user)
				let inputJson;
				if (user.STATUS == "Active") {
					inputJson = { "PROCEDURE": "removerwuser", "USER_ID": parseInt(this.userId), "INACTIVATE_ID": user.USER_ID }
				} else {
					inputJson = { "PROCEDURE": "activaterwuser", "USER_ID": parseInt(this.userId), "ACTIVATE_ID": user.USER_ID }
				}

				user.STATUS = user.STATUS == "Active" ? "Inactive" : "Active";
				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data)
				});
				// let inputJson = { "PROCEDURE": "updaterwuser", "USER_ID": this.userId, "UPDATE_USER_ID": user.USER_ID, "STATUS": user.STATUS == "Active" ? "Inactive" : "Active" }
				// user.STATUS = user.STATUS == "Active" ? "Inactive" : "Active"
				// console.log(inputJson);
				// this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				// 	console.log(data)
				// 	  });
				
			}

		});
	}
	setDefaultResume(e, resume, resumes, index){
		if(e.target.checked){
			let inputJson={"PROCEDURE":"updateresume", "USER_ID": parseInt(this.userId), "RESUME_ID": resume.RESUME_ID,"DEFAULT_RESUME":"Y"};
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}else{
					resumes.splice(index, 1);       // Remove the item from its current position
					resumes.unshift(resume);          // Add the item to the beginning
					for(let item of resumes){
						if(item.RESUME_ID==resume.RESUME_ID){
							item.DEFAULT_RESUME='Y';
						}else{
							item.DEFAULT_RESUME='N';
						}
					}				
				}
			});
		}

	}
	deleteReport(user, resume, index, j) {
		// this.usersList[i].RESUMES.splice(j, 1)
		// for(let i=0; i<this.usersList.length;i++){
		// 	if(this.usersList[i].RESUMES.RESUME_ID==resume.RESUME_ID){
		// 		this.ngZone.run(() => {
		// 			this.usersList[i].RESUMES.splice(j, 1)
		// 		})
		// 	}			
		// }
		user.RESUMES.splice(j, 1);
		let inputJson = { "PROCEDURE": "deleteuserresume", "USER_ID": parseInt(this.userId), "RESUME_ID": resume.RESUME_ID }
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
		});
	}
	deleteUser(user, i) {
		//	this.usersList.splice(i, 1);
		for (let i = 0; i < this.usersList.length; i++) {
			if (this.usersList[i].USER_ID == user.USER_ID) {
				this.ngZone.run(() => {
					this.usersList.splice(i, 1)
				})
			}
		}
		let inputJson = { "PROCEDURE": "removerwuser", "USER_ID": parseInt(this.userId), "REMOVE_USER_ID": user.USER_ID };
		console.log("deleteUser", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
		});
	}
	;
	changeUserDetails(type, user) {
		let inputJson = { "PROCEDURE": "updaterwuser", "USER_ID": parseInt(this.userId), "UPDATE_USER_ID": user.USER_ID, }
		inputJson[type] = user[type + "_TOEDIT"];
		user[type] = user[type + "_TOEDIT"];
		console.log('changeUserDetails', inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
		});
	}
	deleteIndex;
	toDeleteFile;
	resumeToDelete: any = null;
	signatureStyleToDelete: any = null;

	dismissConfirm(event) {
		$('#deleteModal').modal('hide');
		$('#updateStyleModal').modal('hide');
		$('#deleteResumeModal').modal('hide');
		$('#signatureStyleSettingsModal').modal('hide');
		$('#deleteSignatureStyleModal').modal('hide');
	}

	showDeleteResumeConfirm(user, resume, i, j) {
		this.resumeToDelete = { user, resume, i, j };
		$('#deleteResumeModal').modal('show');
	}

	confirmDeleteResume() {
		if (this.resumeToDelete) {
			this.deleteReport(this.resumeToDelete.user, this.resumeToDelete.resume, this.resumeToDelete.i, this.resumeToDelete.j);
			this.resumeToDelete = null;
			$('#deleteResumeModal').modal('hide');
		}
	}
	deleteFile(row) {
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 41};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse);
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				let inputJson = { "PROCEDURE": "deleteuploadfilev2", "USER_ID": parseInt(this.userId), "FILE_ID": row.FILE_ID }
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						return										
					}
					for (let i = 0; i < this.companyFiles.length; i++) {
						if (this.companyFiles[i].FILE_ID == row.FILE_ID) {
							this.companyFiles.splice(i, 1);
						}
					}
				});
				
			}

		})
	}
	companyFiles;
	numFiles
	filesLoading = false
	getCompanyFiles(type) {
		// this.insertCompanyFile();
		this.groupKey = type;
		this.filesLoading = true
		let inputJson = { "PROCEDURE": "getcompanyfiles", "USER_ID": parseInt(this.userId), "COMPANY_ID": this.companyInfo.COMPANY_ID, "FILE_TYPE": type }
		console.log("getcompanyfiles", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.filesLoading = false
			this.companyFiles = data.RW_UPLOAD_FILES
			this.numFiles = data.RW_UPLOAD_FILES.length
		});
	}
	companyRolesHolder = []
	getCompanyRoles() {
		// this.insertCompanyRoles();
		let inputJson = { "PROCEDURE": "getcompanyroles", "USER_ID": parseInt(this.userId), "COMPANY_ID": this.companyInfo.COMPANY_ID }
		console.log("getcompanyroles", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.roles = data.RW_ROLES
			this.companyRolesHolder = this.roles
			console.log('ROLES',data.RW_ROLES)
		});	
	}

	uploadNewFilePermission = false;
	checkUploadNewFilePermission() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 41};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.uploadNewFilePermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way 
				setTimeout(() => { $('#newFile').modal('hide'); }, 250);
			} else {
				this.uploadNewFilePermission = true;

			}

		});
	}
	uploadNewFile() {
		let files=this.newFile.nativeElement.files;
		for (let file of files){  //for multiple files
			if (!file) {
				//$('#inputWarn').css('display', 'inline-block');
				return
			}
			const ext = file.name.replace(/.+\./, '');
		   if (this.acceptType.indexOf(ext) === -1) {
			   Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			   
			   return;
		   }
	   }
		for (let file of files) {
			let that = this;
			let reader = new FileReader();	
			reader.onloadend = function (e) {
				let data = e.target.result.toString().split(',')[1];; console.log(data)//upload service
				//let inputJson={"filename":file.name,"customerid":that.userId,"Order":'123',"reportID":'123','r':'123',"fdata":data}; console.log(inputJson)
				let inputJson = { "filename": file.name, "fdata": data, "user_id": parseInt(that.userId), 'file_type': that.newFileType }
				that.reportService.uploadFile2(inputJson).subscribe(result => {
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.newFileUrl.push(result.FILE_URL);
					that.fileInfo.push(result);
					that.companyFiles = [result, ...that.companyFiles]
				})
			}
			reader.readAsDataURL(file);
		}
	}
	fileDesc = ''
	newFileUrl;
	newFileType;
	fileInfo;
	types = ['IMAGE', "FILE", "LOGO", "BKIMAGE"];
	clearFileForm() {
		this.fileDesc = '';
		this.newFileUrl = [];;
		this.newFileType = null;;
		this.fileInfo = [];;
		this.newFile ? this.newFile.nativeElement.value = "" : console.log("null");
	}
	insertCompanyFile() {
		$('#newFile').modal('hide');
		/*for(let i=0; i< this.newFile.nativeElement.files.length;i++){
			let inputJson= {"PROCEDURE":"insertuploadfilev2","USER_ID":parseInt(this.userId),
			"COMPANY_ID":this.companyInfo.COMPANY_ID,
			"FILE_TYPE":this.newFileType,"FILE_NAME":this.fileInfo[i].FILE_NAME,"FILE_DESCRIPTION":this.fileDesc,
			"FILE_URL":this.newFileUrl[i],"FILE_TN_URL":this.fileInfo[i].FILE_NAME,"FILE_LOCATION":this.fileInfo[i].FILE_LOCATION,"BK_IMAGE_IND":"Y"}
			$('#newFile').modal('hide');
			console.log("insertCompanyFile", inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if(this.newFileType==this.groupKey){
					this.companyFiles=[data,...this.companyFiles]
				}
			});
		}*/
	}
	editFileID;
	updateCompanyFile() {
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 41};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse);
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				let inputJson = { "PROCEDURE": "updateuploadfilev2", "USER_ID": parseInt(this.userId), "FILE_ID": this.editFileID, "FILE_DESCRIPTION": this.fileDesc }
				$('#newFile').modal('hide');
				console.log("insertCompanyFile", inputJson)
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						return										
					}
					for (let i = 0; i < this.companyFiles.length; i++) {
						if (this.companyFiles[i].FILE_ID == this.editFileID) {
							this.companyFiles[i] = data;
						}
					}
				});
			}

		});
	}
	companyAddress1;
	companyCity;
	companyERIS;
	companyCount;
	companyZip;
	companyState;
	companyAddress2
	locationName;
	headOffice = false;
	status;
	companyAddress;
	addCompanyLocation() {
		//{"PROCEDURE":"insertrwlocation","USER_ID":5,"COMPANY_ID":1,"COMPANY_NAME":"Wenck Toronto","ADDRESS_LINE1":"123 Main St","ADDRESS_LINE2":"","CITY":"Toronto","PROVSTATE":"ON","POSTALZIP":"M5M2Y1","COUNTY":"","COUNTRY":"CAN","HEAD_OFFICE":"N","ERIS_BRANCH_ID":null}
		let inputJson = {
			"PROCEDURE": "insertrwlocation",
			"USER_ID": parseInt(this.userId),
			"COMPANY_ID": this.companyInfo.COMPANY_ID,
			"LOCATION_NAME": this.locationName,
			"ADDRESS_LINE1": this.companyAddress1,
			"ADDRESS_LINE2": this.companyAddress2,
			"CITY": this.companyCity,
			"PROVSTATE": this.companyState,
			"POSTALZIP": this.companyZip,
			"COUNTRY": this.companyCount,
			"ERIS_BRANCH_ID": this.companyERIS,
			"HEAD_OFFICE": this.headOffice ? "Y" : "N"
		}
		$('#companyModal').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			this.companyInfo.RW_LOCATIONS = [data, ...this.companyInfo.RW_LOCATIONS];
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.getCords1(data);
			this.clearCompanyLocation();
		});
	}
	deleteCompanyLocation(location) {
		if (!this.manageCompanyPermission) {
			let info={'MESSAGE':this.manageCompanyPermissionMessage};
			this.throwError(info);
		} else {
			//let inputJson={"PROCEDURE":"removerwlocation", "USER_ID":parseInt(this.userId), "LOCATION_ID":location.LOCATION_ID}

			// for(let i=0; i<this.usersList.length;i++){
			// 	if(this.usersList[i].USER_ID==user.USER_ID){
			// 		this.ngZone.run(() => {
			// 			this.usersList.splice(i, 1)
			// 		})
			// 	}			
			// }
			//this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//	console.log(data);
			// });
			console.log(location)
			let that = this;
			let inputJson;
			if (location.STATUS == "Active") {
				inputJson = { "PROCEDURE": "removerwlocation", "USER_ID": parseInt(this.userId), "LOCATION_ID": location.LOCATION_ID };
			} else {
				inputJson = { "PROCEDURE": "activaterwlocation", "USER_ID": parseInt(this.userId), "LOCATION_ID": location.LOCATION_ID }

			}
			location.STATUS = location.STATUS == "Active" ? "Inactive" : "Active";
			console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data)
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
			});
			//			Swal.fire({
			//				icon:'warning',
			//				title: 'Are you sure you want to delete this item?',
			//				confirmButtonText: 'Delete',
			//				showLoaderOnConfirm: true,
			//				showCancelButton: true,
			//				backdrop:false,
			//				preConfirm: () => {
			//					let inputJson={"PROCEDURE":"removerwlocation", "USER_ID":parseInt(this.userId), "LOCATION_ID":location.LOCATION_ID};
			//					console.log(inputJson);
			//					that.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			//						console.log(response);
			//						let info=JSON.parse(response);
			//						let Toast=Swal.mixin({
			//							toast: true,						
			//							position: 'center',
			//							showConfirmButton: false,
			//							timer: 3000
			//						})
			//						if(info.STATUS=="Y"){
			//							that.companyInfo.RW_LOCATIONS.splice(i, 1);
			//							Toast.fire({
			//								icon: 'success',
			//								title: info.MESSAGE,
			//							})
			//			
			//						}else{
			//							Toast.fire({
			//								icon: 'error',
			//								title: info.MESSAGE,
			//							})
			//						}
			//					})
			//				}
			//			})
		}
		
	}

	locationId;
	companyRemoveIndex;
	popupControl = true;
	changeHead(user) {
		if (!this.manageCompanyPermission) {
			let info={'MESSAGE':this.manageCompanyPermissionMessage};
			this.throwError(info);
		} else {
			let inputJson = {
				"PROCEDURE": "updaterwlocation",
				"USER_ID": parseInt(this.userId),
				"LOCATION_ID": user.LOCATION_ID,
				"HEAD_OFFICE": user.HEAD_OFFICE
			}
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log('change head office', data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				//this.companyInfo.RW_LOCATIONS=[data, ...this.companyInfo.RW_LOCATIONS];
				for (let i = 0; i < this.companyInfo.RW_LOCATIONS.length; i++) {
					if (this.companyInfo.RW_LOCATIONS[i].LOCATION_ID == this.locationId) {
						this.companyInfo.RW_LOCATIONS[i] = data;
					}
				}
				user.HEAD_OFFICE= (user.HEAD_OFFICE=='Y')? 'N' : 'Y';
				console.log(data);
			});
		}
	}
	changeSuperAdmin(user) {
		let updaterwuserJson = {
			"PROCEDURE": "updaterwuser",
			"USER_ID": parseInt(this.userId),
			"UPDATE_USER_ID": user.USER_ID,
			"SUPER_ADMIN_USER": (user.SUPER_ADMIN_USER == 'Y') ? 'N' : 'Y'
		};
		this.reportService.univeralService(JSON.stringify(updaterwuserJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}

			user.SUPER_ADMIN_USER = (user.SUPER_ADMIN_USER == 'Y') ? 'N' : 'Y';
		});
	}
	changeLocation() {
		console.log("changelocationhere")
		let inputJson =//{"PROCEDURE":"updaterwlocation","USER_ID":parseInt(this.userId), "LOCATION_ID":this.locationId, "ADDRESS_LINE1": this.companyAddress1}
		{
			"PROCEDURE": "updaterwlocation",
			"USER_ID": parseInt(this.userId),
			"LOCATION_ID": this.locationId,
			"COMPANY_ID": this.companyInfo.COMPANY_ID,
			"LOCATION_NAME": this.locationName,
			"ADDRESS_LINE1": this.companyAddress1,
			"ADDRESS_LINE2": this.companyAddress2,
			"CITY": this.companyCity,
			"PROVSTATE": this.companyState,
			"POSTALZIP": this.companyZip,
			"COUNTRY": this.companyCount,
			"ERIS_BRANCH_ID": this.companyERIS,
			"HEAD_OFFICE": this.headOffice ? "Y" : "N"
		}
		$('#companyModal').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('changeLocationdata', data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			//this.companyInfo.RW_LOCATIONS=[data, ...this.companyInfo.RW_LOCATIONS];
			for (let i = 0; i < this.companyInfo.RW_LOCATIONS.length; i++) {
				if (this.companyInfo.RW_LOCATIONS[i].LOCATION_ID == this.locationId) {
					this.companyInfo.RW_LOCATIONS[i] = data;
				}
			}
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data);
			} else {
				console.log(data);
				this.getCords1(data);
				this.clearCompanyLocation();
				if (this.popupControl) {
					Swal.fire({
						icon: 'success',
						html: data.MESSAGE,
					});
				}
				this.popupControl = true;
			}
		});
	}
	addResume(f, user) {

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "EDIT_USER_ID":user.USER_ID, "FUNCTION_ID": 32};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				const file = this.resume.nativeElement.files[0]; console.log(file)
				const ext = file.name.replace(/.+\./, '');
				if (this.acceptType.indexOf(ext) === -1) {
					Swal.fire('Oops...', ext + ' file Type is not acceptable..');
					return;
				}
				let that = this;
				let reader = new FileReader();
				reader.onloadend = function (e) {
					let data = e.target.result.toString().split(',')[1];; console.log(data)
					let inputJson = { "filename": file.name, "fdata": data, "user_id": parseInt(that.userId), "file_type": "USER_RESUME" };
					that.reportService.uploadFile2(inputJson).subscribe(result => {
						if (result.RESPONSE_STATUS=='N') {
							that.throwError(result);
							return										
						}
						console.log("result", result);
						that.curRptPara.RESUME = result; console.log("RESUME", that.curRptPara.RESUME);
						that.resume.nativeElement.value = null;
						let inputJson2 = { "PROCEDURE": "insertuserresume", "USER_ID": that.userId, "RESUME_FILENAME": that.curRptPara.name, "RESUME_TITLE": that.curRptPara.name, "RESUME_URL": that.curRptPara.RESUME.FILE_URL }
						that.curRptPara = {
							'RESUME': { "FILE_URL": "" },
							'SIGNATURE': {},
							'name': 'Choose File',
						};
						inputJson2["RESUME_USER_ID"] = user.USER_ID;
						that.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data2 => {
							console.log(data2);
							if (data2.RESPONSE_STATUS=='N') {
								that.throwError(data2)
								return										
							}
							that.ngZone.run(() => {
								user.RESUMES.push(data2);
							});
						});
					})
				}
				reader.readAsDataURL(file);
				
			}

		});

	}

	getCompanyGroups() {
		let getcompanygroupsJson = {"PROCEDURE":"getcompanygroups", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(getcompanygroupsJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data);
				return;
			}
			this.companyGroups = data.GROUP_LIST;
		});
	}

	getCompanyGroupUserList() {
		let getcompanygroupuserlistJson = {"PROCEDURE":"getcompanygroupuserlist", "USER_ID":parseInt(this.userId)};	
		this.reportService.univeralService(JSON.stringify(getcompanygroupuserlistJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}

			this.companyGroupUserList = data.RW_USERS;

			// only require user id, full name and email for groups tab
			this.companyGroupUserList = data.RW_USERS.map(user => ({
				USER_ID: user.USER_ID,
				USER_EMAIL: user.USER_EMAIL,
				FULL_NAME: user.FULL_NAME
			}));
		});
	}

	inputGroupSelectedUser = null;
	inputGroupName = '';
	inputGroupUsers = [];
	inputGroupID;


	insertCompanyGroup() {
		if (!this.inputGroupName || this.inputGroupName.trim() === '') {
			this.throwError({ MESSAGE: 'Group name cannot be empty' });
			return;
		}

		if (this.companyGroups.find(group => group.GROUP_NAME === this.inputGroupName)) {
			this.throwError({ MESSAGE: 'Group name already exists' });
			return;
		}

		let inputJson = {
			"PROCEDURE": "insertcompanygroup",
			"USER_ID": parseInt(this.userId),
			"GROUP_NAME": this.inputGroupName
		};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return;							
			}
			data.USERS = [];
			this.companyGroups = [data, ...this.companyGroups];
			
			// once the new group is created in the backend, add the users from input to the group
			let newInputJson = {
				"PROCEDURE": "adduserlisttogroup",
				"USER_ID": parseInt(this.userId),
				"GROUP_ID": data.GROUP_ID,
				"USER_LIST": this.inputGroupUsers.map(user => user.USER_ID).join(',')
			};

			this.reportService.univeralService(JSON.stringify(newInputJson)).subscribe(data => {
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return;							
				}

				this.companyGroups[0].USERS = this.inputGroupUsers;
			});
		});

		$('#groupModal').modal('hide');
	}

	updateCompanyGroupName() {
		if (!this.inputGroupName || this.inputGroupName.trim() === '') {
			this.throwError({ MESSAGE: 'Group name cannot be empty' });
			return;
		}

		if (this.companyGroups.find(group => group.GROUP_NAME === this.inputGroupName
				&& group.GROUP_ID !== this.inputGroupID)) {
			this.throwError({ MESSAGE: 'Group name already exists' });
			return;
		  }

		let inputJson = {
			"PROCEDURE": "updatecompanygroup",
			"USER_ID": parseInt(this.userId),
			"GROUP_ID": this.inputGroupID,
			"GROUP_NAME": this.inputGroupName
		};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data);
				return;
			}

			this.companyGroups.find(group => group.GROUP_ID === this.inputGroupID).GROUP_NAME = this.inputGroupName;
		});

		$('#groupModal').modal('hide');
	}

	removeCompanyGroup(group) {
		let inputJson = {
			"PROCEDURE": "removecompanygroup",
			"USER_ID": parseInt(this.userId),
			"GROUP_ID": group.GROUP_ID
		};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return;							
			}
			group.STATUS = 'Inactive';
		});
	}

	activateCompanyGroup(group) {
		let inputJson = {
			"PROCEDURE": "activatecompanygroup",
			"USER_ID": parseInt(this.userId),
			"GROUP_ID": group.GROUP_ID
		};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return;							
			}
			group.STATUS = 'Active';
		});
	}

	removeUserFromNewGroup(user) {
		this.inputGroupUsers.splice(this.inputGroupUsers.indexOf(user), 1);
		this.inputGroupSelectedUser = null;
	}

	assignUserToNewGroup() {
		if (!this.inputGroupUsers.includes(this.inputGroupSelectedUser)) {
			this.inputGroupUsers.push(this.inputGroupSelectedUser);
		}
		this.inputGroupSelectedUser = null;
	}

	removeUserFromGroup(user) {
		let inputJson = {
			"PROCEDURE": "removeuserfromgroup",
			"USER_ID": parseInt(this.userId),
			"GROUP_ID": this.inputGroupID,
			"REMOVE_USER_ID": user.USER_ID
		};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return;							
			}
			
			this.inputGroupUsers.splice(this.inputGroupUsers.indexOf(user), 1);
			this.inputGroupSelectedUser = null;
		});
	}

	assignUserToGroup() {
		let inputJson = {
			"PROCEDURE": "assignusertogroup",
			"USER_ID": parseInt(this.userId),
			"GROUP_ID": this.inputGroupID,
			"ASSIGN_USER_ID": this.inputGroupSelectedUser.USER_ID
		};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return;							
			}

			if (!this.inputGroupUsers.find(user => user.USER_ID === this.inputGroupSelectedUser.USER_ID)) {
				this.inputGroupUsers.push(this.inputGroupSelectedUser);
			}

			this.inputGroupSelectedUser = null;
		});
	}

	// unused
	addUserListToGroup(userIDs) {
		// let inputJson = {
		// 	"PROCEDURE": "adduserlisttogroup",
		// 	"USER_ID": parseInt(this.userId),
		// 	"GROUP_ID": this.inputGroupID,
		// 	"USER_LIST": userIDs.join(',')
		// };


		// this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		// 	if (data.RESPONSE_STATUS=='N') {
		// 		this.throwError(data)
		// 		return;							
		// 	}
		// });
	}

	excelCols;
	presetCols2 = ["FIRST_NAME", "LAST_NAME", "USER_EMAIL", "JOB_TITLE", "ALTERNATIVE_EMAIL", "PHONE_NUMBER", "ROLE"];
	presetCols = ["FIRST_NAME", "LAST_NAME", "USER_EMAIL", "JOB_TITLE", "ALTERNATIVE_EMAIL", "PHONE_NUMBER", "ROLE"];
	excelJson;

	sheets = [];
	rawExcelJson;
	excelArray
	selectedSheet;
	sheet1;
	resetUpload() {
		this.sheet1 = '';
		this.excelJson = null; this.excelCols = [];
		this.rawExcelJson = null;
		this.excelArray = null;
		this.sheets = [];
		this.selectedSheet = '';
	}
	resetSheet() {
		this.excelJson = null; this.excelCols = [];;
		//this.rawExcelJson=null;
		this.excelArray = null;
	}
	uploadExcel() {
		console.log("uploadExcel")

		let that = this;
		const file = this.excelFile.nativeElement.files[0];
		console.log(file)
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		//this.fileReader.readAsDataURL(file);
		let reader = new FileReader();
		reader.onloadend = function (e) {
			const data = reader.result;
			let workBook = XLSX.read(data, { type: 'binary' });
			let jsonData = workBook.SheetNames.reduce((initial, name) => {
				const sheet = workBook.Sheets[name];
				initial[name] = XLSX.utils.sheet_to_json(sheet);
				return initial;
			}, {});
			//const dataString = JSON.stringify(jsonData);
			console.log(jsonData);

			for (var key in jsonData) {
				if (Object.prototype.hasOwnProperty.call(jsonData, key)) {
					that.sheets.push(key);
				}
			}
			that.selectedSheet = that.sheets[0]
			that.rawExcelJson = jsonData;
			that.resetSheet();
			that.selectSheet()
		}
		reader.readAsBinaryString(file);
	}

	selectSheet() {
		let array = [];
		for (let project of this.rawExcelJson[this.selectedSheet]) {
			for (var key in project) {
				if (Object.prototype.hasOwnProperty.call(project, key)) {
					array.indexOf(key) === -1 ? array.push(key) : console.log("");
				}
			}
		}
		this.excelArray = array;
		for (let col of array) {
			this.excelCols.push({ 'header': col, "changeHeader": col });
		}

		this.excelJson = this.rawExcelJson[this.selectedSheet];
		//that.uploadBatchUsers(jsonData['Sample Data']);
	}
	phoneForm(data) {
		if (!data) {
			return;
		} else {
			return ('(' + data[0] + data[1] + data[2] + ') ' + data[3] + data[4] + data[5] + '-' + data[6] + data[7] + data[8] + data[9])
		}
	}
	hasDuplicates(array) {
		return (new Set(array)).size !== array.length;
	}

	uploadBatchUsersPermission = false;
	checkUploadBatchUsersPermission() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 33};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.uploadBatchUsersPermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way 
				setTimeout(() => { $('#import').modal('hide'); }, 250);
			} else {
				this.uploadBatchUsersPermission = true;
			}

		});
	}
	uploadBatchUsers() {
		this.ngZone.run(() => { this.loading = true; })

		let inputJson = { "PROCEDURE": "batchuploadusers", "USER_ID": parseInt(this.userId), "COMPANY_ID": this.companyInfo.COMPANY_ID, "RW_USERS": this.excelJson }
		console.log('Company ID', this.companyInfo.COMPANY_ID)
		console.log(inputJson);

		let array = [];
		for (let col of this.excelCols) {
			array.push(col.changeHeader);

		}
		if (!array.every(val => this.presetCols.includes(val)) || this.hasDuplicates(array)) {
			this.ngZone.run(() => { this.loading = false; })
			// Swal.fire({
			// 	icon: 'error',
			// 	title: 'Repeated/missing column labels ',
			// });
			let info={'MESSAGE':'Repeated/missing column labels'};
			this.throwError(info);
			return;
		}
		for (let col of this.excelCols) {
			if (col.header != col.changeHeader) {
				for (let project of this.excelJson) {
					delete Object.assign(project, { [col.changeHeader]: project[col.header] })[col.header];
					//this.excelJson[project].PHONE_NUMBER = this.excelJson[project].PHONE_NUMBER?.toString();
					//console.log('P number', this.excelJson[project].PHONE_NUMBER)
				}
			}
		}

		console.log('Excel', this.excelJson);
		//	let inputJson={};
		//for(let i=0; i<this.excelJson.length;i++){
		//	let inputJson=this.excelJson[i];
		//	inputJson.PHONE_NUMBER=inputJson.PHONE_NUMBER?.toString();
		//	inputJson.PROCEDURE="inviterwuser"
		//	inputJson.USER_ID= parseInt(this.userId);
		$('#import').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			console.log('length', data.RW_USERS.length)
			this.loading = false;

			if (data.RESPONSE_STATUS == 'N') {
				if(data.ERRORCODE=='9'){
					this.throwError(data);
				}else{
				Swal.fire({
					html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',//'<p style="font-size:16px; color:red">Login Failed</p>',
					confirmButtonText: 'See Errors',
					showCancelButton: true,
					cancelButtonText: 'OK',
				}).then((result) => {
					if (result.isConfirmed) {
						this.getErrorUploadUsers()
					}
				
			})}
		}else {
				this.ngZone.run(() => {
					//let i = 0
					//while( i < data.RW_USERS.length){
					//	this.usersList.unshift(data.RW_USERS[i]) 
					//	console.log('integer', data.RW_USERS[i])
					//	i++
					//}
					this.getAllReportUsers()
				})
				//if(i==this.excelJson.length-1){
				//	this.getAllReportUsers() 
				//}
				Swal.fire({
					html: data.MESSAGE,
				})
			}
		})
	}
	editFile;
	watermarks;
	headers;
	footers;
	tocstyles;
	logoFiles;
	bodyHeadCss;
	changedSettings;

	reportSettingsDefault = {
		"HEADING1_FONT_STYLE": "Verdana",
		"HEADING1_FONT_SIZE": "18",
		"HEADING2_FONT_STYLE": "Verdana",
		"HEADING2_FONT_SIZE": "14",
		"HEADING3_FONT_STYLE": "Verdana",
		"HEADING3_FONT_SIZE": "14",
		"REPORT_FONT_STYLE": "Verdana",
		"REPORT_BODY_FONT_SIZE": "12",
		"TABLE_HEADER_COLOUR": "#eeeeee",
		"TABLE_HEADER_FONT_COLOUR": "#000000",
		"HEADING1_INDENT": "N",
		"HEADING2_INDENT": "N",
		"HEADING3_INDENT": "N",
		"HEADING1_DESIGN": "",
		"HEADING2_DESIGN": "",
		"HEADING3_DESIGN": "",
		"HEADER_LINE": "Y",
		"FOOTER_LINE": "Y",
		"HEADING1_SPACING": "20", 
		"HEADING2_SPACING": "20", 
		"HEADING3_SPACING": "20",
		"REPORT_MARGIN_TOP": "5", 
		"REPORT_MARGIN_BOTTOM": "5", 
		"REPORT_MARGIN_LEFT": "25",
		"REPORT_MARGIN_RIGHT": "25",
		"DATE_FORMAT_ID":180,
				
	};
	profileQuestionsDefault = {
		"GRANT_ACCESS": "Y",
		"PCA_TABLE_STYLE": "B",

		"APPENDIX_TITLEPAGE_IND": "Y",
		"APPENDIX_TITLEPAGE_FILE_IND": "N",

		"TOC_PAGENUMBER_FORMAT": "int",
		"TOC_STYLE_ID": "1",

		"REPORT_BODY_HEAD": "",
		"REPORT_STYLE_CUSTOMIZED": "N"
	}
	TOCQuestionsDefault= {
		"TOC_MARGIN_TOP": "5",
		"TOC_MARGIN_BOTTOM": "5",
		"TOC_MARGIN_LEFT": "25",
		"TOC_MARGIN_RIGHT": "25",
		"TOC_HF_REPORT_IND": "Y",
		"TOC_HEADER_ID": "",
		"TOC_FOOTER_ID": "",		
	}
	profileQuestions = { ...this.profileQuestionsDefault, ...this.reportSettingsDefault, ...this.TOCQuestionsDefault}

	updateProfile(profileUpdates) {
		if (!this.manageCompanyPermission) {
			let info={'MESSAGE':this.manageCompanyPermissionMessage};
			this.throwError(info);

		} else {
			for (const [key, value] of Object.entries(profileUpdates)) {
				if (profileUpdates[key] === true) {
					profileUpdates[key] = 'Y'
				}
			}
			if (profileUpdates.REPORT_BODY_HEAD) {
				profileUpdates.REPORT_BODY_HEAD = btoa(profileUpdates.REPORT_BODY_HEAD);
			}
			this.profileQuestions = { ...this.profileQuestions, ...profileUpdates };
	
			let procedure = 'updaterwprofile'//;this.companyInfo.RW_PROFILE_SETTINGS[0] ? 'updaterwprofile' : 'insertrwprofile';
				let id=this.profileQuestions['COMP_PROFILE_ID'];
				if(id){
				let inputJson = { "PROCEDURE": procedure, "USER_ID": parseInt(this.userId), "COMPANY_ID": this.companyInfo.COMPANY_ID, 'COMP_PROFILE_ID':id, ...profileUpdates };
				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(procedure, "=>", data);
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						return										
					}
					let pSettings=data.RW_PROFILE_SETTINGS[0];
					this.profileQuestions = JSON.parse(JSON.stringify(pSettings));
				if (pSettings.TOC_STYLE) {
					this.profileQuestions.TOC_STYLE_ID = pSettings.TOC_STYLE.TOC_STYLE_ID;
				}
				if (pSettings.DATE_FORMAT) {
					this.profileQuestions.DATE_FORMAT_ID = pSettings.DATE_FORMAT.DATE_FORMAT_ID;
				}
				if(pSettings.TOC_HEADER){
					this.profileQuestions.TOC_HEADER_ID = pSettings.TOC_HEADER.TOC_HEADER_ID;
				}
				if(pSettings.TOC_FOOTER){
					this.profileQuestions.TOC_FOOTER_ID = pSettings.TOC_FOOTER.TOC_FOOTER_ID;
				}
				this.bodyHeadCss = atob(pSettings.REPORT_BODY_HEAD);
				})
			}else{
				this.createNewProfile();
			}
			}	}
	createNewProfile(){
			let name='';
			let inputJson:any;
			let procedure='InsertCompanyStyle';
				let that=this;
				Swal.fire({
					title: 'Please input Profile Name to create company profile.',
					inputAttributes: {
					autocapitalize: 'off'
				},
			  html: '<input type="text" #name id="name" class="form-control mb-2" placeholder="Enter your profile name"></input>',
			  confirmButtonText: 'Save',
			  showLoaderOnConfirm: true,
			  showCancelButton: true,
			  backdrop:false,
			  preConfirm: () => {
				let title = $('#name').val().trim();
				if (title === '') {
				  Swal.showValidationMessage(`Profile name empty`)
				}				
				if(title.length==0) return	
				name=title;
				inputJson = { "PROCEDURE": procedure, "USER_ID": parseInt(that.userId), "COMPANY_ID": this.companyInfo.COMPANY_ID, 'REPORT_STYLE_NAME':name};
				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(procedure, "=>", data);
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						return										
					}
					let newStyle={'COMP_PROFILE_ID':data.COMP_PROFILE_ID,'REPORT_STYLE_NAME':data.REPORT_STYLE_NAME};
					this.profiles.push(newStyle);
				});
		}
		})
	}
	updateBodyHead() {
		const answers = this.profileQuestions;
		this.changedSettings.HEADING1_FONT_STYLE = answers.HEADING1_FONT_STYLE;
		this.changedSettings.HEADING1_FONT_SIZE = answers.HEADING1_FONT_SIZE;
		this.changedSettings.HEADING2_FONT_STYLE = answers.HEADING2_FONT_STYLE;
		this.changedSettings.HEADING2_FONT_SIZE = answers.HEADING2_FONT_SIZE;
		this.changedSettings.HEADING3_FONT_STYLE = answers.HEADING3_FONT_STYLE;
		this.changedSettings.HEADING3_FONT_SIZE = answers.HEADING3_FONT_SIZE;
		this.changedSettings.REPORT_FONT_STYLE = answers.REPORT_FONT_STYLE;
		this.changedSettings.REPORT_BODY_FONT_SIZE = answers.REPORT_BODY_FONT_SIZE;
		this.changedSettings.HEADING1_INDENT = answers.HEADING1_INDENT;
		this.changedSettings.HEADING2_INDENT = answers.HEADING2_INDENT;
		this.changedSettings.HEADING3_INDENT = answers.HEADING3_INDENT;
		this.changedSettings.TABLE_HEADER_COLOUR = answers.TABLE_HEADER_COLOUR;
		this.changedSettings.TABLE_HEADER_FONT_COLOUR = answers.TABLE_HEADER_FONT_COLOUR;
		this.changedSettings.REPORT_BODY_HEAD = this.bodyHeadCss;
	}

	updateBodyHeadCss() {
		if (this.profileQuestions.REPORT_STYLE_CUSTOMIZED == 'Y') {
			return;
		}
		const answers = this.profileQuestions;
		this.bodyHeadCss = `<style>
* { padding: 0; margin: 0; box-sizing: border-box; }
html { font-size: ${answers.REPORT_BODY_FONT_SIZE}px; font-family: ${answers.REPORT_FONT_STYLE}, Helvetica, sans-serif; }
body { margin: 0; }
.page-before { display: block; page-break-before: always; }
.page-after { display: block; page-break-after: always; }
h1 { margin: ${answers.HEADING1_FONT_SIZE}px ${answers.HEADING1_INDENT == 'Y' ? '2em' : '0'}; font-size: ${answers.HEADING1_FONT_SIZE}px; font-family: ${answers.HEADING1_FONT_STYLE}; font-weight: bold; }
h2 { margin: ${answers.HEADING2_FONT_SIZE}px ${answers.HEADING2_INDENT == 'Y' ? '2em' : '0'}; font-size: ${answers.HEADING2_FONT_SIZE}px; font-family: ${answers.HEADING2_FONT_STYLE}; font-weight: bold; }
h3 { margin: ${answers.HEADING3_FONT_SIZE}px ${answers.HEADING3_INDENT == 'Y' ? '2em' : '0'}; font-size: ${answers.HEADING3_FONT_SIZE}px; font-family: ${answers.HEADING3_FONT_STYLE}; font-weight: bold; }
ol, ul { padding: 0 0 1em 1.5em; }
input[type="checkbox"] { display: none; }
input[type="checkbox"] { background: url('https://erisservice8.erisinfo.com/exreportw/hf/square-uncheck.svg') no-repeat; display: inline-block;	height: 1rem; width: 1.2rem; }
input[type="checkbox"]:checked { background: url('https://erisservice8.erisinfo.com/exreportw/hf/square-check.svg') no-repeat; display: inline-block; height: 1rem; width: 1.2rem; }
.todo-list { list-style-type: none; padding-left: 0; }
table { width: 100%; border-collapse: collapse; }
table thead { display: table-header-group; }
table thead tr th { padding: 8px; background-color: ${answers.TABLE_HEADER_COLOUR}; color: ${answers.TABLE_HEADER_FONT_COLOUR}; font-size: 10px; font-weight: 600; border: 1px solid #000; border-collapse: collapse; }
table tbody tr td { padding: 8px; font-size: 10px; border: 1px solid #000; border-collapse: collapse; }
td.sub-header {vertical-align: middle;}
td.align-left,td.align-left * {text-align: left;}
td.align-center,td.align-center * {text-align: center;}
td.align-right,td.align-right * {text-align: right;}
table tr { page-break-inside: avoid! important;margin: 4px 0 4px 0;}
@page landscape {size: 11in 8.5in;}
@page portrait { size: 8.5in 11in; }
@page legal-landscape-page { size: 14in 8.5in; }
@page legal-portrait-page { size: 8.5in 14in; }
@page ledger-landscape-page { size: 17in 11in; }
@page ledger-portrait-page { size: 11in 17in; }
div.landscape-content { page: landscape; }
div.portrait-content { page: portrait; }
div.legal-landscape { page: legal-landscape-page; }
div.legal-portrait { page: legal-portrait-page; }
div.ledger-landscape { page: ledger-landscape-page; }
div.ledger-portrait { page: ledger-portrait-page; }
</style>`;
	}

	updateReportSettings() {
		this.updateBodyHeadCss();
		this.updateBodyHead();
		this.updateProfile(this.changedSettings);
		this.changedSettings = {};
	}

	updateCustomStyle() {
		this.changedSettings.REPORT_STYLE_CUSTOMIZED = "Y";
		this.changedSettings.REPORT_BODY_HEAD = this.bodyHeadCss;
		this.updateProfile(this.changedSettings);
		this.changedSettings = {};
	}
	updateAdditional(){
		const answers = this.profileQuestions;
		this.changedSettings.HEADING1_DESIGN=answers.HEADING1_DESIGN;
		this.changedSettings.HEADING2_DESIGN=answers.HEADING2_DESIGN;
		this.changedSettings.HEADING3_DESIGN=answers.HEADING3_DESIGN;
		this.changedSettings.HEADER_LINE=answers.HEADER_LINE;
		this.changedSettings.FOOTER_LINE=answers.FOOTER_LINE;
		this.changedSettings.HEADING1_SPACING=answers.HEADING1_SPACING.toString();
		this.changedSettings.HEADING2_SPACING=answers.HEADING2_SPACING.toString();
		this.changedSettings.HEADING3_SPACING=answers.HEADING3_SPACING.toString();
		this.changedSettings.REPORT_MARGIN_TOP=answers.REPORT_MARGIN_TOP.toString();
		this.changedSettings.REPORT_MARGIN_BOTTOM=answers.REPORT_MARGIN_BOTTOM.toString();
		this.changedSettings.REPORT_MARGIN_LEFT=answers.REPORT_MARGIN_LEFT.toString();
		this.changedSettings.REPORT_MARGIN_RIGHT=answers.REPORT_MARGIN_RIGHT.toString();
		this.changedSettings.DATE_FORMAT_ID=answers.DATE_FORMAT_ID;
		this.updateProfile(this.changedSettings);
		this.changedSettings = {};
	}
	updateTOC(){
		const answers = this.profileQuestions;
		this.changedSettings.TOC_MARGIN_TOP=answers.TOC_MARGIN_TOP;
		this.changedSettings.TOC_MARGIN_BOTTOM=answers.TOC_MARGIN_BOTTOM;
		this.changedSettings.TOC_MARGIN_LEFT=answers.TOC_MARGIN_LEFT;
		this.changedSettings.TOC_MARGIN_RIGHT=answers.TOC_MARGIN_RIGHT;
		this.changedSettings.TOC_HF_REPORT_IND=answers.TOC_HF_REPORT_IND;
		this.changedSettings.TOC_HEADER_ID=answers.TOC_HEADER_ID;
		this.changedSettings.TOC_FOOTER_ID=answers.TOC_FOOTER_ID;
		this.updateProfile(this.changedSettings);
		this.changedSettings = {};
	}

	resetCustomStyle() {
		this.profileQuestions = { ...this.profileQuestions, ...this.reportSettingsDefault, ...this.TOCQuestionsDefault };
		this.changedSettings.REPORT_STYLE_CUSTOMIZED = "N";
		this.profileQuestions.REPORT_STYLE_CUSTOMIZED = "N";
		this.updateBodyHeadCss();
		this.updateBodyHead();
		this.updateProfile(this.changedSettings);
		this.changedSettings = {};
	}

	htmlShow = false;
	dragDisabled = false;
	setDrag(data) {
		if (data) {
			this.dragDisabled = true;
		} else {
			this.dragDisabled = false;
		}
	}

	open(index: number): void {
		this.lightbox.open(this.tocstyles, index);
	}

	close(): void {
		this.lightbox.close();
	}
	sideNavWidth = '66px'
	toggleSideBarVar = false
	toggleSideBar() {
		if (this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if (this.toggleSideBarVar == true) {
			this.sideNavWidth = '66px'
			this.toggleSideBarVar = false
		}
	}
	setDefault(id){
		 let inputJson={"PROCEDURE":"updaterwprofile","USER_ID":parseInt(this.userId),'COMPANY_ID':this.userInfo.COMPANY_ID.toString(), "ACTIVE_LOGO_ID":id};
	  	console.log(inputJson);		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			console.log(response);
			if(response.RESPONSE_STATUS=='Y'){
				this.getCompanyFiles('LOGO');
				let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				Toast.fire({
					icon: 'success',
					title: response.MESSAGE,
				})
			}else{
				this.throwError(response);
			}
		})	
	}
	errorUploadCols = [
			{ field: 'EDIT', header: '', searchField: '', width: '4%' }, // this is for the edit button column
			{ field: 'FIRST_NAME', header: 'First Name', searchField: 'FIRST_NAME',width: '5%' },
			{ field: 'LAST_NAME', header: 'Last Name', searchField: 'LAST_NAME', width: '5%' },
			{ field: 'USER_EMAIL', header: 'Email', searchField: 'USER_EMAIL', width: '14%' },
			{ field: 'PHONE_NUMBER', header: 'Phone Number', searchField: 'PHONE_NUMBER', width: '8%' },
			{ field: 'JOB_TITLE', header: 'Job Title', searchField: 'JOB_TITLE', width: '8%' },
			// { field: 'RESUMES', header: 'Resumes', searchField: 'RESUMES', width: '10%' },
			// { field: 'SIGNATURE_URL', header: 'Signature', searchField: 'SIGNATURE_URL', width: '7%' },
			// { field: 'SEAL_URL', header: 'Seal', searchField: 'SEAL_URL', width: '5%' },
			// { field: 'EXTERNAL_USER', header: 'Ext', searchField: 'EXTERNAL_USER', width: '3%' },
			// { field: 'ERIS_USERNAME', header: 'Eris ID', searchField: 'ERIS_USERNAME', width: '5%' },
			{ field: 'ROLE_NAME', header: 'Role', searchField: 'ROLE_NAME', width: '10%' },
			// { field: 'DATE_CREATED', header: 'Created Date', searchField: 'DATE_CREATED', width: '7%' },
			// { field: 'LAST_LOGIN_DATE', header: 'Last Login',searchField: 'LAST_LOGIN_DATE',  width: '7%' },
			// { field: 'STATUS', header: 'Status', searchField: 'STATUS', width: '5%' },
			{ field: 'BATCH_LOAD_DATE', header: 'Batch Upload Date', searchField: 'BATCH_LOAD_DATE', width: '8%' },
			{ field: 'LOAD_MESSAGE', header: 'Load Message', searchField: 'LOAD_MESSAGE', width: '10%' },


		]
	companyUsersBounded = true
	errorUserListBounded = false
	getErrorUploadUsers() {
		// let string = '01234567891'
		// console.log(string.length)
		// string = string.substring(0,10)
		// console.log(string)
		// console.log(string.length)
		//if(string.length>10)
		if(this.companyUsersBounded){
			let inputJson = {
				"PROCEDURE": "geterroruploadusers",
				"USER_ID": parseInt(this.userId),
			}
			console.log(inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				for(let i=0;i<data.RW_USER_ERROR_LIST.length;i++){
					data.RW_USER_ERROR_LIST[i].PHONE_NUMBER = data.RW_USER_ERROR_LIST[i].PHONE_NUMBER.replace(/\D/g,'')
					if(data.RW_USER_ERROR_LIST[i].PHONE_NUMBER.length>10){
						data.RW_USER_ERROR_LIST[i].PHONE_NUMBER = data.RW_USER_ERROR_LIST[i].PHONE_NUMBER.substring(0,10)
						console.log(data.RW_USER_ERROR_LIST[i].PHONE_NUMBER)
						console.log('test')
					}
					console.log(data.RW_USER_ERROR_LIST[i].PHONE_NUMBER)
				}
				this.usersList = data.RW_USER_ERROR_LIST
				this.cols=this.errorUploadCols
				this.totalUsers = this.usersList.length;
				this.companyUsersBounded = false
				this.errorUserListBounded = true
			})
		}
		if(this.errorUserListBounded){
			this.cols = [
				{ field: 'FIRST_NAME', header: 'First Name', searchField: 'FIRST_NAME',width: '8%' },
				{ field: 'LAST_NAME', header: 'Last Name', searchField: 'LAST_NAME', width: '8%' },
				{ field: 'USER_EMAIL', header: 'Email', searchField: 'USER_EMAIL', width: '14%' },
				{ field: 'PHONE_NUMBER', header: 'Phone Number', searchField: 'PHONE_NUMBER', width: '8%' },
				{ field: 'JOB_TITLE', header: 'Job Title', searchField: 'JOB_TITLE', width: '8%' },
				{ field: 'RESUMES', header: 'Resumes', searchField: 'RESUMES', width: '10%' },
				{ field: 'SIGNATURE_URL', header: 'Signature', searchField: 'SIGNATURE_URL', width: '7%' },
				{ field: 'SEAL_URL', header: 'Seal', searchField: 'SEAL_URL', width: '5%' },
				{ field: 'EXTERNAL_USER', header: 'Ext', searchField: 'EXTERNAL_USER', width: '3%' },
				{ field: 'ERIS_USERNAME', header: 'Eris ID', searchField: 'ERIS_USERNAME', width: '5%' },
				{ field: 'ROLE_NAME', header: 'Role', searchField: 'ROLE_NAME', width: '10%' },
				{ field: 'GROUPS', header: 'Groups', searchField: 'GROUPS', width: '8%' },
				{ field: 'DATE_CREATED', header: 'Created Date', searchField: 'DATE_CREATED', width: '7%' },
				{ field: 'LAST_LOGIN_DATE', header: 'Last Login',searchField: 'LAST_LOGIN_DATE',  width: '7%' },
				{ field: 'STATUS', header: 'Status', searchField: 'STATUS', width: '5%' },
			]
			this.getAllReportUsers();
			//this.usersList = this.usersListCached
			//this.totalUsers = this.usersList.length;
			this.companyUsersBounded = true
			this.errorUserListBounded = false
		}

	} 
	uploadExcel1() {
		//console.log("uploadExcel")

		let that = this;
		const file = this.excelFile1.nativeElement.files[0];
		//console.log(file)
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		let reader = new FileReader();
		reader.onloadend = function (e) {
			const data = reader.result;
			let workBook = XLSX.read(data, { type: 'binary' });console.log(workBook);
			let jsonData = workBook.SheetNames.reduce((initial, name) => {
				const sheet = workBook.Sheets[name];console.log(sheet);
				initial[name] = XLSX.utils.sheet_to_json(sheet, {header: 0, raw: false});console.log(initial);
				return initial;
			}, {});
			//const dataString = JSON.stringify(jsonData);
			console.log(jsonData);

			for (var key in jsonData) {
				if (Object.prototype.hasOwnProperty.call(jsonData, key)) {
					//that.sheets.push(key);
					that.sheets[0]=key;
				}
			}
			//console.log(that.sheets)
			that.selectedSheet = that.sheets[0]
			that.rawExcelJson = jsonData;
			that.resetSheet();
			that.selectSheet()
		}
		reader.readAsBinaryString(file);
	}
	uploadBatchClientrsPermission=false
	checkUploadBatchClientPermission(){
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 42};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.uploadBatchClientrsPermission = false; 

				// close the modal. the timeout is to give it time to load. very hacky, find a better way 
				setTimeout(() => { $('#import').modal('hide'); }, 250);
			} else {
				this.uploadBatchClientrsPermission = true;
			}

		});
	}
	//presetCols3 = ["COMPANY_NAME", "ADDRESS_LINE1", "ADDRESS_LINE2", "CITY", "PROVSTATE", "POSTALZIP", "COUNTRY", "CONTACT_NAME", "CONTACT_TITLE", "CONTACT_PHONE", "CONTACT_EMAIL"];
	presetCols3 =['CLIENT_ADDRESS_LINE1',
	"CLIENT_ADDRESS_LINE2",
	"CLIENT_CITY",
	"CLIENT_COMPANY_NAME",
	"CLIENT_CONTACT_EMAIL",
	"CLIENT_CONTACT_NAME",
	"CLIENT_CONTACT_PHONE",
	"CLIENT_CONTACT_TITLE",
	"CLIENT_COUNTRY",
	"CLIENT_POSTALZIP",
	"CLIENT_PROVSTATE",
	]
	uploadBatchClients() {
		this.ngZone.run(() => { this.loading = true; })

		let inputJson = { "PROCEDURE": "batchuploadclients", "USER_ID": parseInt(this.userId), "RW_CLIENTS": this.excelJson }
		console.log(inputJson);

		let array = [];
		for (let col of this.excelCols) {
			array.push(col.changeHeader);

		}
		if (!array.every(val => this.presetCols3.includes(val)) || this.hasDuplicates(array)) {
			this.ngZone.run(() => { this.loading = false; })

			throwError('Repeated/missing column labels');
			return;
		}
		
		for (let col of this.excelCols) {
			if (col.header != col.changeHeader) {
				for (let project of this.excelJson) {
					delete Object.assign(project, { [col.changeHeader]: project[col.header] })[col.header];
				}
			}
		}

		console.log('Excel', this.excelJson);
		$('#import1').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			//console.log('length', data.RW_CLIENTS.length)
			this.loading = false;

			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
		}else {
				this.ngZone.run(() => {
					this.companyClients = [...data.RW_CLIENTS, ...this.companyClients];
					
				})
				Swal.fire({
					html: data.MESSAGE,
				})
			}
		})
	}
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
	  removeTOCHF(e){
		if(e.target.value=='Y'){
			this.profileQuestions.TOC_HEADER_ID='';
			this.profileQuestions.TOC_FOOTER_ID='';		
		}
	  }
	  profiles=[]
	getCompanyProfiles(){
	  let inputJson={"PROCEDURE":"getcompanystylelist","USER_ID":parseInt(this.userId)};
	  this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		  console.log(data);
		  if (data.RESPONSE_STATUS=='N') {
			  this.throwError(data)
			  return										
		  }
		  this.profiles=data.STYLE_LIST;
		  
	  })
	}
	insertCompanyProfile(){
	  let inputJson={"PROCEDURE":"insertcompanystyle","USER_ID":parseInt(this.userId),"REPORT_STYLE_NAME":"Test New Style"};
	  this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		  console.log(data);
		  if (data.RESPONSE_STATUS=='N') {
			  this.throwError(data)
			  return										
		  }
		  this.profileQuestions = JSON.parse(JSON.stringify(data));
			  if (data.TOC_STYLE) {
				  this.profileQuestions.TOC_STYLE_ID = data.TOC_STYLE.TOC_STYLE_ID;
			  }
			  if (data.DATE_FORMAT) {
				  this.profileQuestions.DATE_FORMAT_ID = data.DATE_FORMAT.DATE_FORMAT_ID;
			  }
			  if(data.TOC_HEADER){
				  this.profileQuestions.TOC_HEADER_ID = data.TOC_HEADER.TOC_HEADER_ID;
			  }
			  if(data.TOC_FOOTER){
				  this.profileQuestions.TOC_FOOTER_ID = data.TOC_FOOTER.TOC_FOOTER_ID;
			  }
			  this.bodyHeadCss = atob(data.REPORT_BODY_HEAD);
	  })
  }
  getCompanyProfile(e){
	  let id=$(e.target).val();console.log(id)
	  if(id.length>0){
		  let inputJson={"PROCEDURE":"getcompanyprofile","USER_ID":parseInt(this.userId),"COMP_PROFILE_ID":id};console.log(inputJson);
		  this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			  console.log(data);
			  if (data.RESPONSE_STATUS=='N') {
				  this.throwError(data)
				  return										
			  }
			  this.profileQuestions = JSON.parse(JSON.stringify(data));
			  if (data.TOC_STYLE) {
				  this.profileQuestions.TOC_STYLE_ID = data.TOC_STYLE.TOC_STYLE_ID;
			  }
			  if (data.DATE_FORMAT) {
				  this.profileQuestions.DATE_FORMAT_ID = data.DATE_FORMAT.DATE_FORMAT_ID;
			  }
			  if(data.TOC_HEADER){
				  this.profileQuestions.TOC_HEADER_ID = data.TOC_HEADER.TOC_HEADER_ID;
			  }
			  if(data.TOC_FOOTER){
				  this.profileQuestions.TOC_FOOTER_ID = data.TOC_FOOTER.TOC_FOOTER_ID;
			  }
			  this.bodyHeadCss = atob(data.REPORT_BODY_HEAD);
		  })
	  }else{
		  this.profileQuestions['COMP_PROFILE_ID']='';
	  }
	  
	}
	  fmesetupdata=[];
	  fmePcadata=[];
	  fmeSradata=[];
	  fmeZondata=[];
	  fmeOpt=['User Input', 'Repeat Field'];
	  showPca='p1';
	  toEsa(){
		let inputJson={"PROCEDURE":"getcompanyfmephase1","USER_ID":parseInt(this.userId)};		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.fmesetupdata=data.FME_SETUP;
			}
		})
		this.showPca='p1';		
		//this.getslot();
	  }
	  toFme(){
		let inputJson={"PROCEDURE":"getcompanyfmepca","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.fmePcadata=data.FME_SETUP;
			}
		})
		this.showPca='pca';

	  }
	  toSeismic(){
		let inputJson={"PROCEDURE":"getcompanyfmesra","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.fmeSradata=data.FME_SETUP;
			}
		})
		this.showPca='sra';

	  }
	  toZone(){
		let inputJson={"PROCEDURE":"getcompanyfmezon","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.fmeZondata=data.FME_SETUP;
			}
		})
		this.showPca='zone';

	  }
	  updateFme(fItem, rf?){console.log(fItem, rf)
		let inputJson:any
		if(rf){
			inputJson={"PROCEDURE":"updatecompanyfmerf","USER_ID":parseInt(this.userId),"FME_ID":fItem.FME_ID,"SLOT_ID":rf.SLOT_ID}; // Assign RF
		}else{
			inputJson={"PROCEDURE":"updatecompanyfmerf","USER_ID":parseInt(this.userId),"FME_ID":fItem.FME_ID}; //Remove RF
		}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				if(rf){
					fItem.RF_ASSIGNED=rf;
				}else{
					fItem.RF_ASSIGNED={};
				}
				
			}
		})
	  }
	  slots=[];
	  filtedSlot=[];
	  getslot(){
		let inputJson={"PROCEDURE":"getslotsbytypelist","USER_ID":parseInt(this.userId),"TYPE_LIST":"Selection,Narrative,Monetary"};//2 optional parameters - ERIS_TABLE(Y) and/or ACTIVE_ONLY(Y) .
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.slots=data.RW_SLOTS;
			this.filtedSlot=this.slots
			}
		})
	}
	filterSlot(e){
		let val=e.target.value;
		this.filtedSlot=this.slots.filter(slot => slot.KEY.toUpperCase().indexOf(val.toUpperCase())>-1); console.log(this.filtedSlot);
	}
	closerEnvdata=[];
	closerSeisdata=[];
	closerZoningdata=[];
	closerEngdata=[];
	closerOpt=['User Input', 'Repeat Field'];
	showCloser='env';
	toCloserEnv(){
		let inputJson={"PROCEDURE":"getcompanycloserenviro","USER_ID":parseInt(this.userId)};		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.closerEnvdata=data.CLOSER_SETUP;
			}
		})
		this.showCloser='env';	
	}
	toCloserSeismic(){
		let inputJson={"PROCEDURE":"getcompanycloserseismic","USER_ID":parseInt(this.userId)};		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.closerSeisdata=data.CLOSER_SETUP;
			}
		})
		this.showCloser='sei';
	}
	toCloserZoning(){
		let inputJson={"PROCEDURE":"getcompanycloserzoning","USER_ID":parseInt(this.userId)};		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.closerZoningdata=data.CLOSER_SETUP;
			}
		})
		this.showCloser='zon';
	}
	toCloserEng(){
		let inputJson={"PROCEDURE":"getcompanyclosereng","USER_ID":parseInt(this.userId)};		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
			this.closerEngdata=data.CLOSER_SETUP;
			}
		})
		this.showCloser='eng';
	}
	updateCloser(fItem, rf?){
		let inputJson:any
		if(!fItem.CLOSER_ID) return
		if(rf&&rf.SLOT_ID>-1){
			inputJson={"PROCEDURE":"updatecompanycloserrf","USER_ID":parseInt(this.userId),"CLOSER_ID":fItem.CLOSER_ID,"SLOT_ID":rf.SLOT_ID}; // Assign RF
		}else{
			inputJson={"PROCEDURE":"updatecompanycloserrf","USER_ID":parseInt(this.userId),"CLOSER_ID":fItem.CLOSER_ID}; //Remove RF
		}		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				if(rf){
					fItem.RF_ASSIGNED=rf;
				}else{
					fItem.RF_ASSIGNED={};
				}
				
			}
		})
	}	
	
	checkCloserSettingsPermission(type) {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 56};
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				return
			}else{
				if(type=='closer'){
					this.showCloser='env'; this.toCloserEnv();this.getslot();
					$('#closerModal').modal('show');
				}else if(type=='fme'){
					this.showPca='p1'; this.toEsa(); this.getslot();
					$('#fmeModal').modal('show');
				}
				
			}
		});
	}
	branches=[];	
	getBranchIds(){
		this.branches=[];
		let inputJson={"PROCEDURE":"geterisbranches","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.branches=data.BRANCHES;			
			}
		})	
	}
	branchInfo:any;
	getBrahchInfo(id){
		this.branchInfo=null;
		let inputJson={"PROCEDURE":"geterisbranchinfo","USER_ID":parseInt(this.userId),"ERIS_BRANCH_ID":id}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.branchInfo=data;
				Swal.fire({
					icon:'info',
					html: 'Would you like to use ERIS Branch Information as input?<br><br>'
					+'<div style="text-align:left; margin-left:20px"><b>Office Location: </b>'+data.ERIS_BRANCH_NAME+'<br><b>Address1: </b>'+data.ADDRESS_LINE1+'<br><b>Address2: </b>'+data.ADDRESS_LINE2+'<br>'
					+'<b>City: </b>'+data.CITY+'<br>'
					+'<b>State/Province: </b>'+data.PROVSTATE+'<br>'
					+'<b>Zip/Postal: </b>'+data.POSTALZIP+'<br>'
					+'<b>Country: </b>'+data.COUNTRY+'<br>',
					confirmButtonText: 'Yes',
					showLoaderOnConfirm: true,
					showCancelButton: true,
					backdrop:false,
					preConfirm: () => {
						this.companyAddress1 = data.ADDRESS_LINE1;
						this.companyAddress2 = data.ADDRESS_LINE2;
						this.companyState = data.PROVSTATE;
						this.companyZip = data.POSTALZIP;
						this.companyCount = data.COUNTRY;
						this.companyCity = data.CITY;
						this.companyAddress = data.FULL_ADDRESS;
						this.locationName = data.ERIS_BRANCH_NAME;						
					}
				})	
			}
		})
	}
	signTemps=[];
	getSignTemps(){
		let inputJson={"PROCEDURE":"getsignaturestyletemplates","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.signTemps=data.SIGNATURE_STYLE_TEMPLATES;
				
			}
		})	
	}
	signStyles=[];
	getSignStyles(){
		let inputJson={"PROCEDURE":"GetSignatureStyleList","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.signStyles=data.RW_SIGNATURE_STYLES;				
			}
		})	
	}
	signatureroles=[];
	getSignRoles(){
		let inputJson={"PROCEDURE":"getsignaturelabels","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.signatureroles=data.RW_SIGNATURE_LABELS;
				
			}
		})				
	}
	alignments=[];
	getAlignments(){
		let inputJson={"PROCEDURE":"getsignaturealignment"}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.alignments=data.RW_SIGNATURE_ALIGNMENTS;				
			}
		})
	}

	newSignShow = false;
	signShow = false;

	selectedSign: any;
	newsignProfile: any = { id: null, name: null };


	submitted = false;


	private get baseTemplateValid(): boolean {

	return !!this.newsignProfile?.id;
	}
	private get profileNameValid(): boolean {
	const name = this.newsignProfile?.name;
	return typeof name === 'string' && name.trim().length > 0;
	}


	get showBaseTemplateError(): boolean {
	return this.submitted && !this.baseTemplateValid;
	}
	get showProfileNameError(): boolean {
	return this.submitted && !this.profileNameValid;
	}


	createNewSignatureStyle() {
	this.getSignTemps();
	this.newSignShow = true;
	this.signShow = false;
	this.submitted = false;                 
	this.newsignProfile = { id: null, name: null };
	}


	createNewSignProfile() {
	this.submitted = true;           

	if (typeof this.newsignProfile?.name === 'string') {
		this.newsignProfile.name = this.newsignProfile.name.trim();
	}


	if (!this.baseTemplateValid || !this.profileNameValid) return;


	const inputJson = {
		"PROCEDURE": "insertsignaturestyle",
		"USER_ID": parseInt(this.userId),
		"SS_TEMPLATE_BASE_ID": this.newsignProfile.id,
		"SIGNATURE_STYLE_NAME": this.newsignProfile.name
	};

	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		if (data.RESPONSE_STATUS == 'N') {
		this.throwError(data);
		} else {
		const item = {
			"SIGNATURE_STYLE_ID": data.SIGNATURE_STYLE_ID,
			"SIGNATURE_STYLE_NAME": this.newsignProfile.name
		};
		this.signStyles.unshift(item);


		this.newsignProfile = { id: null, name: null };
		this.submitted = false;             

		const Toast = Swal.mixin({
			toast: true,
			position: 'center',
			showConfirmButton: false,
			timer: 3000
		});
		Toast.fire({
			icon: 'success',
			title: 'Your signature profile has been created successfully!'
		});
		}
	});
	}

	toEditSignature(){
		this.signShow=true;
		this.getSignContent(this.selectedSign['SIGNATURE_STYLE_ID']);
	}
	getSignContent(id){
		let inputJson={"PROCEDURE":"getsignaturestyle","USER_ID":parseInt(this.userId),"SIGNATURE_STYLE_ID":id}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				let base64content=data["SIGNATURE_STYLE_TEMPLATE"];
				this.selectedSign['SIGNATURE_STYLE_TEMPLATE']=atob(base64content);
				this.selectedSign['SIGNATURE_STYLE_NAME']=data["SIGNATURE_STYLE_NAME"];
			}
		})	
	}
	upateSignProfile(){
		let content=btoa(this.selectedSign['SIGNATURE_STYLE_TEMPLATE']);
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure, you want to update Signature Style Settings?',
			confirmButtonText: 'Update',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"updatesignaturestyle","USER_ID":parseInt(that.userId),"SIGNATURE_STYLE_ID":this.selectedSign['SIGNATURE_STYLE_ID'],"SIGNATURE_STYLE_NAME":this.selectedSign['SIGNATURE_STYLE_NAME'], "SIGNATURE_STYLE_TEMPLATE":content};
			 	console.log(inputJson);
			 	that.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			 		console.log(response);
			 		let info=JSON.parse(response);
			 		let Toast=Swal.mixin({
			 			toast: true,						
			 			position: 'center',
			 			showConfirmButton: false,
			 			timer: 3000
			 		})
			 		if(info.RESPONSE_STATUS=="Y"){
			 				that.signShow=false;
			 				Toast.fire({
			 					icon: 'success',
			 					title: info.MESSAGE,
			 				})
			 		}else{
			 			Swal.fire({
			 				icon: 'error',
			 				title: info.MESSAGE,
			 			})
			 		}
			 	})
			}
		})
	}
	setSignAlign(e){
		let align=e.target.value;
		let inputJson={"PROCEDURE":"updaterwcompany","USER_ID":parseInt(this.userId),"COMPANY_ID":this.companyInfo.COMPANY_ID,"SIGNATURE_ALIGNMENT_CODE":align}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		if (data.STATUS == 'N') {
				this.throwError(data)
			}else {
				let Toast=Swal.mixin({
			 		toast: true,						
			 		position: 'center',
			 		showConfirmButton: false,
			 		timer: 3000
			 	})
			 	Toast.fire({
			 		icon: 'success',
			 		title: data.MESSAGE,
			 	})
			 	this.companyInfo['RW_PROFILE_SETTINGS'][0]['COMPANY_SIGNATURE_ALIGNMENT']['SIGNATURE_ALIGNMENT_CODE']=align;
			}
		})
	}
	setOnBehalf(e){
		let ifOnBehalf='N'
		if(e.target.checked){
			ifOnBehalf='Y'
		}
		let inputJson={"PROCEDURE":"updaterwcompany","USER_ID":parseInt(this.userId),"COMPANY_ID":this.companyInfo.COMPANY_ID,"SIGN_ONBEHALF_OTHERS":ifOnBehalf}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data)
		if (data.STATUS == 'N') {
				this.throwError(data)
			}else {
				let Toast=Swal.mixin({
			 		toast: true,						
			 		position: 'center',
			 		showConfirmButton: false,
			 		timer: 3000
			 	})
			 	Toast.fire({
			 		icon: 'success',
			 		title: data.MESSAGE,
			 	})
			 	
			}
		})
	}
	updateSignatureRole(e, role){
		let inputJson={"PROCEDURE":"updatesignaturelabel","USER_ID":parseInt(this.userId),"SIGNATURE_LABEL_ID":role.SIGNATURE_LABEL_ID,"SIGNATURE_LABEL_VALUE":e};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		if (data.RESPONSE_STATUS != 'Y') {
				this.throwError(data)
			}else {
				let index=this.signatureroles.findIndex(item=>item.SIGNATURE_LABEL_ID==role.SIGNATURE_LABEL_ID);
				if(index>-1){
					this.signatureroles[index].SIGNATURE_LABEL_NAME=e;
				}
				let Toast=Swal.mixin({
			 		toast: true,						
			 		position: 'center',
			 		showConfirmButton: false,
			 		timer: 3000
			 	})
			 	Toast.fire({
			 		icon: 'success',
			 		title: data.MESSAGE,
			 	})
			 	
			}
		})
	}

	isDefaultStyle(styleName: string): boolean {
		if (!styleName) return false;
		const normalizedName = styleName.toLowerCase().trim();
		return normalizedName === 'default style'
	}

	openSignatureStyleSettings() {
		$('#signatureStyleSettingsModal').modal('show');
	}

	showDeleteSignatureStyleConfirm(style: any) {
		this.signatureStyleToDelete = style;
		$('#deleteSignatureStyleModal').modal('show');
	}

	confirmDeleteSignatureStyle() {
		if (this.signatureStyleToDelete) {
			let inputJson = {
				"PROCEDURE": "deletesignaturestyle",
				"USER_ID": parseInt(this.userId),
				"SIGNATURE_STYLE_ID": this.signatureStyleToDelete.SIGNATURE_STYLE_ID
			};

			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				if (data.RESPONSE_STATUS == 'Y') {
					const index = this.signStyles.findIndex(style => style.SIGNATURE_STYLE_ID === this.signatureStyleToDelete.SIGNATURE_STYLE_ID);
					if (index > -1) {
						this.signStyles.splice(index, 1);
					}

					if (this.selectedSign && this.selectedSign.SIGNATURE_STYLE_ID === this.signatureStyleToDelete.SIGNATURE_STYLE_ID) {
						this.selectedSign.SIGNATURE_STYLE_ID = null;
					}

					let Toast = Swal.mixin({
						toast: true,
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					});
					Toast.fire({
						icon: 'success',
						title: data.MESSAGE || 'Signature style deleted successfully',
					});

					this.signatureStyleToDelete = null;
					$('#deleteSignatureStyleModal').modal('hide');
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Error',
						text: data.MESSAGE || 'Failed to delete signature style',
					});
				}
			}, error => {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'An error occurred while deleting the signature style',
				});
			});
		}
	}
}
